const ru = {
  common: {
    search: 'Поиск',
    tb: 'ТБ',
    active: 'Актив',
    inactive: 'Неактив',
    sort_by: 'Сортировать по',
    edit: 'Редактировать',
    delete: 'Удалить',
    save: 'Сохранить изменения',
    cancel: 'Отмена',
    all: 'Все',
    save_success: 'Данные успешно сохранены',
    description: 'Описание',
    optional: 'Необязательно',
    level: 'Уровень',
    add: 'Добавить',
    institution: 'Институт',
    role: 'Роль',
    add_option: 'Добавить опцию',
    finished: 'Завершено',
    today: 'Сегодня',
    yesterday: 'Вчера',
    see_details: 'Посмотреть детали',
    view_more: 'Показать больше',
    confirm: 'Подтвердить',
    select_from_list: 'Выбрать из списка',
    date: 'Число',
    department: 'Отдел',
    by_department: 'По отделу',
    type: 'Тип',
    product: 'Продукт',
    group: 'Группа',
    medicine: 'Препарат',
    quantity: 'Количество',
    unit: 'Единица измерения',
    producer: 'Производитель',
    contract_number: 'Номер контракта',
    pieces: 'шт.',
    code: 'Код',
    commercial_name: 'Международное общепринятое название',
    international_name: 'Международное название',
    commercial_naming: 'Торговое название',
    active_component: 'Активный компонент',
    production_date: 'Дата производства',
    expiration_date: 'Срок годности',
    info: 'Информация',
    age: 'Возраст',
    years: 'годы',
    view: 'Просмотр',
    case: 'Случай',
    close: 'Закрыть',
    yes: 'Да',
    no: 'Нет',
    see_all_list: 'Посмотреть полный список',
    phone: 'Телефон',
    comment: 'Комментарий',
    leave_comment: 'Оставить комментарий',
    total: 'Всего',
    invoice: 'Счет',
    invoice_number: 'Номер счета',
    phone_label: 'Телефон',
    or: 'или',
    accept: 'Принять',
    decline: 'Отклонить',
    sime_code: 'Код SIME',
    action: 'Действие',
    back: 'Назад',
    import: 'Импортировать',
    export: 'Экспортировать',
    upload_document: 'Загрузить документ',
    by_company: 'По компании',
    send: 'Отправить',
    transport: 'Транспорт',
    sent: 'Отправлено',
    instructions: 'Инструкции',
    enter_text: 'Введите текст',
    user: 'Пользователь',
    default: 'По умолчанию',
    delete_description: 'Это действие необратимо.',
    save_description: 'Это действие сохранит изменения.',
    success_delete: 'Данные успешно удалены',
    doctor: 'Врач',
    doctors_2_to_4: 'Врача',
    doctors: 'Врачей',
    details: 'Детали',
    country: 'Страна',
    filters: 'Фильтры',
    server_error: 'Что-то пошло не так.',
    tarv_code: 'Код ТАРВ',
    tarv_code_update_error: 'Не удалось обновить код ТАРВ.',
    citizenship: 'Гражданство',
    person: 'Человек',
    min_one_quantity: 'Количество должно быть больше 0',
    ong: 'ОНГ',
    laboratory: 'Лаборатория',
    hour: 'Время',
    treatment: 'Лечение',
    medical_institution: 'Медицинское учреждение',
    columns: 'Столбцы',
    order: 'Порядок',
    comments: 'Комментарии',
    access: 'Перейти',
    select: 'Выбрать',
    patient: 'Пациент',
    cost_per_unit_with_tva: 'Стоимость за единицу',
    total_tva: 'Общая сумма с НДС',
    measure_unit: 'Единица измерения',
    tva: 'Таможенная пошлина',
    months: 'месяцы',
    pharmaceutics: 'Парафармацевтика',
    medicines: 'Медицина',
    price_unit: 'Цена за единицу (MDL)',
    update: 'Обновить',
    delivered_quantity: 'Количество доставленное',
    outstanding_quantity: 'Количество оставшееся',
    testrap_code: 'Код TESTRAP',
    remove: 'Удалить',
    remove_assigned_medic: 'Удалить {{name}}, назначенного врача',
    belongs: 'Принадлежит'
  },
  auth: {
    logout: 'Выйти из аккаунта',
    login_title: 'Авторизация',
    login_subtitle:
      'Введите ваши данные для входа или создайте новую учетную запись администратора с помощью MPass.',
    remember_me: 'Запомнить меня',
    reset_password: 'Сбросить пароль',
    mpass_auth: 'Авторизация с MPass',
    forgot_password_title: 'Забыли пароль?',
    forgot_password_subtitle:
      'Не волнуйтесь, мы вышлем вам инструкции по сбросу.',
    send_instructions: 'Отправить инструкции по сбросу',
    remember_password: 'Вспомнили пароль?',
    return_to_auth: 'Вернуться к аутентификации',
    check_email: 'Проверьте электронную почту',
    check_email_subtitle:
      'Мы отправили инструкции для подтверждения аккаунта на ваш адрес электронной почты.',
    check_email_description:
      'Не получили письмо? Проверьте папку со спамом или',
    try_again: 'попробуйте ещё раз',
    create_new_password: 'Создать новый пароль',
    create_new_password_subtitle:
      'Пожалуйста, введите новый пароль и убедитесь, что выбираете надежный пароль.',
    login_error: 'Ошибка: неверное имя пользователя или пароль."',
    not_have_account: 'У вас нет аккаунта?',
    signup: 'Зарегистрироваться',
    create_new_account: 'Создать новый аккаунт',
    signup_description: 'Введите свои данные для создания нового аккаунта',
    signup_success: 'Аккаунт успешно создан',
    email_change_success: 'Электронная почта успешно изменена',
    email_change_error: 'Недействительный адрес электронной почты',
    resend_email_success: 'Электронное письмо успешно отправлено',
    confirm_account_success: 'Аккаунт успешно подтвержден',
    confirm_account_error: 'Произошла ошибка при подтверждении аккаунта',
    confirm_otp_subtitle:
      'Мы отправили код подтверждения на ваш адрес электронной почты. Пожалуйста, проверьте ваш почтовый ящик и введите код подтверждения ниже, чтобы подтвердить ваш адрес электронной почты.',
    verification_code: 'Код подтверждения',
    resend_code: 'Отправить код повторно',
    reset_password_request_success: 'Запрос на сброс пароля успешно отправлен',

    passwordRegex: {
      password: 'Пароль должен содержать от',
      characters: 'символов',
      lowercase: 'Минимум одна строчная буква',
      uppercase: 'Минимум одна заглавная буква',
      number: 'Минимум одна цифра',
      special: 'Минимум один специальный символ',
      weak: 'Слабый',
      medium: 'Средний',
      strong: 'Сильный',
      level: 'Уровень',
      levelReq: 'Пароль должен содержать'
    },
    wrong_otp: 'Неверный OTP код'
  },
  menu: {
    organizational_structure: 'Организационная структура',
    other_institutions: 'Другие учреждения',
    users: 'Пользователи',
    reports: 'Отчеты',
    classifiers: 'Классификаторы',
    notification_templates: 'Шаблоны уведомлений',
    templates: 'Шаблоны',
    roles: 'Роли',
    logs: 'Журналы',
    settings: 'Настройки',
    appointments: 'Записи',
    notifications: 'Уведомления',
    treatments: 'Лечение',
    tests_results: 'Результаты теста',
    stock: 'Запас',
    analysis: 'Анализ',
    cases: 'Cлучаи',
    visits: 'Посещения',
    transfers: 'Перевод пациентов',
    liberations: 'Освобождения',
    reports_administration: 'Администрирование отчетов',
    persons: 'Люди',
    persons_management: 'Люди и пациенты',
    persons_from_screening: 'Люди из скрининга',
    support_investigation: 'Поддержка расследований',
    recipes: 'Рецепты',
    medicines_register: 'Реестр Мед-Конс',
    consumable_medicaments: 'Расходные медикаменты',
    stock_institution: 'Запасы учреждения',
    issuance: 'Выдача',
    ong_support: 'Поддержка НПО',
    riskGroups: 'Группы риска',
    localStock: 'Склад специалиста',
    tests: 'Пробы',
    investigations: 'Исследования',
    platform_settings: 'Настройки платформы',
    questionnaires: 'Aнкеты',
    investigation_templates: 'Шаблоны расследований',
    systemSettings: 'Настройки системы',
    patients: 'Пациенты',
    equipments: 'Оборудование',
    prescriptions: 'Рецепты',
    stock_groups: 'Группы акций',
    funding_source: 'Источник финансирования',
    active_substances: 'Активное вещество',
    device_types: 'Типы устройств',
    laboratory_classifiers: 'Классификаторы лаборатории',
    risk_groups: 'Группы риска',
    treatment_types_classifier: 'Классификаторы лечения',
    cuatm: 'Классификатор CUATM'
  },
  form: {
    required: 'Это поле обязательно для заполнения',
    email: 'Электронная почта',
    email_address: 'Адрес электронной почты',
    email_error: 'Введите корректный адрес электронной почты',
    email_placeholder: 'Введите ваш адрес электронной почты',
    password: 'Пароль',
    repeat_password: 'Повторите пароль',
    confirm_password_error: 'Пароли не совпадают',
    last_name: 'Фамилия',
    first_name: 'Имя',
    birth_date: 'Дата рождения',
    gender: 'Пол',
    male: 'Мужской',
    female: 'Женский',
    unknown: 'Неопределённый',
    medical_institution: 'Медицинское учреждение',
    idnp: 'ИНН',
    contact_number: 'Контактный телефон',
    status: 'Статус',
    address: 'Адрес проживания',
    idnp_error: 'Введите правильный ИНН',
    city: 'Город',
    street: 'Улица',
    building: 'Номер дома',
    apartment_number: 'Номер квартиры',
    notes: 'Заметки',
    fiscal_code_error: 'Введите действительный налоговый код',
    social_status: 'Статус социального положения',
    current_password: 'Текущий пароль',
    new_password: 'Новый пароль',
    confirm_password: 'Повторите пароль',
    change_password: 'Изменить пароль',
    contact_date: 'Дата контакта',
    include_anonymous: 'Показать анонимных пользователей',
    not_include_anonymous: 'Скрыть анонимных пользователей',
    testrapCode: 'Код TESTRAP',
    add_prison: 'Добавить данные',
    progress: 'Прогресс'
  },
  notifications: {
    title: 'Уведомления',
    read_all: 'Отметить все как прочитанные',
    see_all: 'Просмотреть все уведомления',
    notifications_type: 'Тип уведомления',
    empty_text: 'Нет уведомлений',
    today: 'Сегодня',
    yesterday: 'Вчера',
    minutes: 'минуты',
    minute: 'минута',
    now: 'Сейчас',
    ago: 'назад',
    hour: 'час',
    hours: 'часа',
    zero_notifications: 'У вас нет уведомлений',
    search_placeholder: 'Поиск уведомлений',
    from_date: 'С даты',
    to_date: 'По дату',
    view_details: 'Просмотреть детали'
  },
  pageHeader: {
    main_page: 'Главная'
  },
  organizational_structure: {
    add_button: 'Добавить медицинское учреждение',
    tree: 'Дерево',
    organioram: 'Организационная структура',
    profile: 'Профиль учреждения',
    structure: 'Организационная структура',
    structure_logic: 'Логическая структура',
    equipment: 'Оборудование',
    idno: 'ИДНО',
    idno_error: 'Введите правильный ИДНО из 13 цифр',
    name: 'Название учреждения',
    type: 'Тип',
    phone: 'Контактный телефон',
    fax: 'Факс',
    email: 'Электронная почта',
    cuatm_code: 'Код CUATM',
    cuatm_code_placeholder: 'Введите код',
    city: 'Город',
    street: 'Улица',
    region: 'Регион',
    services: 'Услуги, предоставляемые учреждением',
    lab: 'Расследования',
    other: 'Прочее',
    institutions: 'Учреждения',
    phone_error: 'Номер телефона должен начинаться с +373 и содержать 8 цифр.',
    institution_classification: 'Классификация учреждения по принадлежности',
    caseDeclarerInstitutionId: 'Представляет учреждение',
    declaresCases: 'Заявить случаи',
    tracksCases: 'Ведёт учет случаев',
    isWithoutCode: 'Учреждение без кода',
    equipment_tab: {
      search_placeholder: 'Поиск оборудования',
      add_new_equipment: 'Добавить новое оборудование',
      add_equipment: 'Добавить оборудование',
      unique_number: 'Уникальный код',
      name: 'Название',
      select_equipment: 'Выберите оборудование',
      sort_code_asc: 'Код (А-Я)',
      sort_code_desc: 'Код (Я-А)',
      sort_name_asc: 'Название (А-Я)',
      sort_name_desc: 'Название (Я-А)'
    },
    department_tab: {
      add_button: 'Добавить отдел',
      modal_title: 'Добавить отдел',
      modal_title_edit: 'Редактировать отдел',
      title: 'Название',
      title_placeholder: 'Название отдела',
      search_placeholder: 'Поиск',
      select_from_list: 'Выбрать из списка',
      add_users: 'Добавить пользователей',
      department_group: 'Группа отделов'
    },
    delete_institution_success: 'Учреждение успешно удалено',
    add_success: 'Учреждение успешно добавлено',
    edit_success: 'Учреждение успешно изменено',
    monitoring_institutions_card: 'Локации для мониторинга',
    add_locality: 'Добавить локацию',
    medical_assistance_types: 'Услуги, предоставляемые учреждением',
    roles: 'Роли, назначенные для учреждения',
    intitution_type: 'Тип учреждения',
    laboratory_not_selected:
      'Пожалуйста, выберите лабораторию на вкладке «Общие», чтобы просмотреть доступные исследования.'
  },
  settings: {
    security_settings: 'Настройки безопасности',
    profile_settings: 'Настройки профиля',
    current_password: 'Текущий пароль',
    current_password_placeholder: 'Введите текущий пароль',
    new_password: 'Создать новый пароль',
    new_password_placeholder: 'Введите новый пароль',
    repeat_password: 'Повторите новый пароль',
    repeat_password_placeholder: 'Повторно введите новый пароль',
    change_data: 'Изменить данные',
    password_success_message: 'Пароль успешно изменён',
    profile_success_message: 'Данные успешно сохранены',
    profile_default_language: 'Язык по умолчанию'
  },
  notification_templates: {
    create: 'Создать новый шаблон',
    name: 'Название шаблона',
    notification_title: 'Заголовок уведомления',
    content: 'Содержание',
    create_new_template: 'Создать новый шаблон',
    notification: 'Уведомление',
    type: 'Тип уведомления',
    preview: 'Предварительный просмотр уведомления',
    preview_type: 'Результат теста',
    preview_title: 'Результаты лабораторных исследований',
    preview_content:
      'Результаты анализов для пациента [X] доступны. Просим вас ознакомиться с ними.',
    preview_time: '2 часа назад',
    edit_template: 'Редактировать шаблон',
    event: 'Событие',
    chanel: 'Канал',
    roles: 'Роли',
    email: 'Электронная почта',
    push_notification: 'Push уведомление',
    all: 'Все',
    search_placeholder: 'Поиск шаблона уведомлений',
    success_delete: 'Шаблон успешно удален',
    error_ru: 'Отсутствует контент на русском языке',
    name_asc: 'Имя (А-Я)',
    name_desc: 'Имя (Я-А)',
    event_asc: 'Событие (А-Я)',
    event_desc: 'Событие (Я-А)',
    action_url: 'Ссылка',
    placeholders: 'Плейсхолдеры'
  },
  roles: {
    add_new_role: 'Добавить новую роль',
    system_roles: 'Системные роли',
    custom_roles: 'Пользовательские роли',
    title_role: 'Название роли',
    permissions: 'Разрешения',
    access_level: 'Уровень доступа',
    role_description: 'Описание роли',
    general_permissions: 'Разрешения',
    edit_role: 'Изменение роли',
    system_roles_empty: 'Системная роль отсутствует.',
    custom_roles_empty: 'Настраиваемых ролей нет.',
    patient: 'Пациент',
    medical_institution_user: 'Пользователь медицинского учреждения',
    medical_institution_admin: 'Администратор главного медицинского учреждения',
    central_laboratory_user: 'Пользователь центральной лаборатории',
    private_laboratory_user: 'Пользователь частной лаборатории',
    national_stock_user: 'Пользователь национального запаса',
    medical_institution_stock_user:
      'Пользователь запасов медицинского учреждения',
    pharmacy_user: 'Пользователь аптеки',
    epidemiologist_user: 'Пользователь эпидемиолог',
    national_admin_user: 'Пользователь национального администратора',
    medical_institution_administrator_user:
      'Пользователь администратора медицинского учреждения',
    name_asc: 'Название (А-Я)',
    name_desc: 'Название (Я-А)',
    access_asc: 'Уровень доступа (возрастание)',
    access_desc: 'Уровень доступа (убывание)',
    institutions: 'Учреждения, назначенные для этой роли',
    delete_confirm_title: 'Вы уверены, что хотите удалить эту роль?',
    confirm: 'Подтвердите',
    save: 'Сохранить изменения',
    permission_level: 'Уровень разрешений',
    select_institutions: 'Выберите учреждения',
    select_ong: 'Выберите НПО'
  },

  users: {
    create_new_user: 'Создать нового пользователя',
    last_access_time: 'Дата последнего доступа',
    general_info: 'Общая информация',
    system_roles: 'Роли в системе',
    assignee_role: 'Назначить роль',
    no_roles: 'У этого пользователя нет назначенных ролей.',
    assignee_a_role: 'Назначить роль',
    select_institution: 'Выберите учреждение',
    system_role: 'Роль в системе',
    delete_user_title: 'Вы уверены, что хотите удалить этого пользователя?',
    cancel: 'Отменить',
    name_asc: 'Фамилия (А-Я)',
    name_desc: 'Фамилия (Я-А)',
    birth_date_asc: 'Дата рождения (по возрастанию)',
    birth_date_desc: 'Дата рождения (по убыванию)',
    select_institution_type: 'Выберите тип учреждения',
    authentication_type_email: 'По электронной почте',
    authentication_type_mpass: 'По Mpass',
    authentication_type: 'Тип аутентификации'
  },
  activity: {
    activity: 'Активность',
    search_placeholder: 'Поиск по имени',
    changedInfoText: 'измененная информация о пациенте'
  },
  classifiers: {
    classifiers: 'Классификаторы',
    search_placeholder: 'Поиск классификатора',
    title: 'Название',
    description: 'Описание',
    category: 'Категория',
    elements: 'Элементы из классификатора',
    general: 'Общие',
    delete: 'Вы действительно хотите удалить этот элемент?',
    hasKey: 'Показать порядковый номер',
    result_positivity: 'Позитивность результата',
    positivity_positive: 'Положительный',
    positivity_negative: 'Отрицательный',
    positivity_others: 'Другое',
    system_key: 'Системный ключ',
    system_key_held_by: 'Установлен на: {{name}}',
    system_key_move: 'Перенести ключ с {{name}}?',
    opportunistic_diseases: 'Оппортунистические заболевания (МКБ-10-AM)',
    opportunistic_disease_toggle:
      'Оппортунистическое заболевание (форма 058-1/у, 56)',
    only_marked: 'Только отмеченные'
  },
  appointments: {
    date_and_time: 'Дата и время',
    location: 'Место проведения',
    doctor: 'Врач'
  },
  treatments: {
    id: 'ID',
    type: 'Тип',
    start: 'Начало',
    end: 'Окончание',
    status: 'Статус',
    institution: 'Учреждение',
    treatments_details: 'Детали лечения',
    treatment_type: 'Тип лечения',
    medication_name: 'Название препарата',
    medication_dose: 'Дозировка',
    medication_type: 'Способ применения',
    medication_frequency: 'Частота применения',
    treatment_start_date: 'Дата начала лечения',
    treatment_end_date: 'Дата окончания лечения',
    prescribed_by: 'Назначил',
    report_reactions: 'Сообщить о побочных реакциях',
    reactions: 'Побочные реакции',
    report_reactions_desc: 'Опишите подробнее побочные реакции',
    report_reactions_placeholder: 'Опишите побочные реакции',
    arv_medication: 'Противовирусные препараты',
    opportunistic_diseases:
      'Оппортунистические заболевания/Сопутствующие заболевания',
    concomitant_diseases: 'Сопутствующие заболевания',
    tar_treatment: 'Антиретровирусная терапия (АРТ)',
    event_medication: 'Принимаемые лекарства',
    treatment_start_date_asc: 'Начало лечения (A - Z)',
    treatment_start_date_desc: 'Начало лечения (Z - A)',
    treatment_end_date_asc: 'Конец лечения (A - Z)',
    treatment_end_date_desc: 'Конец лечения (Z - A)',
    treatment_type_asc: 'Тип лечения (A - Z)',
    treatment_type_desc: 'Тип лечения (Z - A)',
    new: 'Активное',
    inProgress: 'В процессе',
    completed: 'Завершено',
    cancelled: 'Приостановлено',
    cancel_treatment: 'Прекратить лечение',
    finish_treatment: 'Закончить лечение',
    person_who_created_the_treatment: 'Человек, создавший лечение:',
    cancel_treatment_title: 'Вы хотите отменить лечение?',
    event_date: 'Дата события',
    cancel_reason: 'Причина отмены',
    next_consultation_date: 'Дата следующей консультации',
    diagnostic_details: 'Детали диагностики',
    diagnostic_date: 'Дата диагностики',
    urgent_treatment: 'Срочное лечение',
    confirm_delete_adverse_reactions:
      'Вы действительно хотите удалить эту побочную реакцию?',
    regiment_type: 'Тип схемы лечения'
  },
  tests_results: {
    type: 'Тип теста',
    result: 'Результат',
    collection_date: 'Дата сбора образца',
    test_date: 'Дата теста',
    result_date: 'Дата результата',
    positive: 'Положительный',
    inconclusive: 'Неопределённый',
    negative: 'Отрицательный',
    registration_number: 'Регистрационный номер',
    save_test_result: 'Сохранить результат',
    test_hiv_1_hiv_2: 'Результат теста на ВИЧ 1/2',
    test_hiv_1: 'ВИЧ 1',
    test_hiv_2: 'ВИЧ 2',
    responsible_person_name: 'Ответственное лицо за тестирование',
    medic_name: 'Врач/консультант, который инициировал тест',
    testing_at_asc: 'Учреждение (A - Z)',
    testing_at_desc: 'Учреждение (Z - A)',
    status_asc: 'Статус (A - Z)',
    status_desc: 'Статус (Z - A)',
    test_type_asc: 'Тип теста (A - Z)',
    test_type_desc: 'Тип теста (Z - A)',
    test_date_asc: 'Дата тестирования (A - Z)',
    test_date_desc: 'Дата тестирования (Z - A)',
    statuses: {
      undefined: 'Неопределен',
      new: 'Новый',
      started: 'В процессе',
      approved: 'Апробирован',
      submittedToValidation: 'Отправлен на проверку',
      rejected: 'Отклонен'
    },
    validated_by: 'Проверено',
    tested_by_initial: 'Врач первичного тестирования',
    created_by: 'Создано',
    received_by: 'Принял',
    approved: 'Одобрено',
    result_value_option: 'Опция значения результата',
    device_result: 'Результат прибора',
    device_test_type: 'Тест прибора',
    cartridge_serial_number: 'Серийный номер картриджа',
    reagent_lot_id: 'Лот реагента',
    cartridge_expiration_date: 'Срок годности картриджа',
    no_results: 'Нет результатов',
    created_institution: 'Учреждение создания',
    validation_institution: 'Учреждение проверки',
    edit_result: 'Редактировать результат',
    confirm_result: 'Подтверждение результата',
    confirm_result_current: 'Подтверждаю введенный результат',
    confirm_result_different: 'Ввожу другой результат',
    result_updated: 'Результат успешно обновлен',
    edit_approved_result_warning:
      'Результат уже отправлен запрашивающему врачу. Изменение будет зарегистрировано.'
  },
  reports: {
    search_by_report_title: 'Поиск по названию отчета',
    report_type: 'Тип отчета',
    report_title: 'Название отчета',
    clinical_administrative_activity_report:
      'Ежегодный отчет о клинической и административной деятельности',
    export_report: 'Экспортировать отчет',
    contract_quantity: 'Количество по контракту',
    contract_value: 'Сумма по контракту',
    amount_purchase: 'Количество приобретенное',
    contract_date: 'Дата контракта',
    by_organizational_structure: 'По организационной структуре',
    generate_report: 'Сгенерировать отчет'
  },
  other_institutions: {
    address: 'Адрес',
    contact_data: 'Контактные данные',
    fiscal_code: 'Код фискальный',
    country: 'Страна',
    number: 'Номер',
    other_institutions_created_success: 'Другое учреждение успешно создано',
    add_institution: 'Добавить учреждение',
    delete_institution: 'Вы уверены, что хотите удалить это учреждение?',
    delete_institution_success: 'Учреждение успешно удалено'
  },
  stock: {
    applications: 'Заявки',
    inputs: 'Вводы',
    returns: 'Возвраты',
    settlement: 'Кассация',
    medicines_includes: 'Лекарства включены',
    add_manual_input: 'Добавить ручной ввод',
    out_of_stock: 'Продукт закончился',
    expired: 'Срок годности истек',
    purchase_documents: 'Документы по закупке',
    input_invoice: 'Счет',
    invoice_date: 'Дата счета',
    entry_management_date: 'Дата включения в учет',
    accompanying_invoice: '№ Счет/Сопроводительный накладная',
    provider: 'Поставщик',
    internal_management_number: 'Внутренний № / Управление',
    management: 'Управление',
    delegate: 'Делегат',
    invoiced_value: 'Сумма по счету',
    car_number: 'Номер машины',
    stocks: 'Запасы',
    stock_entry: 'Поступление на склад',
    confirm_stock_adding: 'Подтвердить добавление на склад',
    add_medicine: 'Добавить лекарство',
    search_placeholder: 'Поиск по наименованию или коду',
    received: 'Получено',
    received_new_stock: 'Вы получили новую партию товара.',
    filled_requests: 'Заполненные запросы',
    production_from: 'Производство с',
    production_to: 'Производство до',
    expiration_from: 'Срок годности с',
    expiration_to: 'Срок годности до',
    return_reason: 'Причина возврата',
    edit_reason: 'Причина редактирования',
    issuance_allowed: 'Разрешено выдача?',
    consumable_settings: 'Настройки расходных материалов',
    delete_group_title: 'Удалить эту группу запасов?',
    delete_group_success: 'Группа была успешно удалена',
    create_group: 'Создайте новую группу',
    create_group_success: 'Группа была успешно создана',
    status_valid: 'Действительный',
    status_expired: 'Истекший',
    status_expireInAWhile: 'Скоро истекает',
    notify_quantity: 'Уведомление о количестве',
    services: 'Дополнительные расходы',
    services_products: 'Дополнительные расходы + Продукт',
    services_add: 'Добавить дополнительные расходы',
    service_name: 'Наименование услуги',
    service_name_select: 'Выберите наименование услуги',
    stock_category: 'Категория склада',
    service_price: 'Стоимость услуги'
  },
  stock_applications: {
    request_medicine: 'Запросить медикаменты',
    request_date: 'Дата запроса',
    refusal_date: 'Дата отказа',
    accepted_date: 'Дата принятия',
    accept: 'Принять',
    view: 'Просмотреть',
    approve_application: 'Утвердить заявку',
    add_medicine: 'Добавить медикамент',
    select_medicine: 'Выбрать медикамент',
    cause: 'Причина/Особые требования',
    cause_placeholder:
      'Краткое описание причины запроса или других особых требований',
    documents: 'Соответствующие документы',
    upload_title: 'Добавить документ здесь или выбрать файл',
    upload_description: 'PDF, DOC или Excel (макс. 5 МБ)',
    medicine_application: 'Запрос на лекарства',
    stock_application: 'Запрос на склад',
    number: 'Нр.',
    juridic_person: 'Юридическое лицо',
    consumables: 'Расходные материалы',
    confirmed: 'Доставлено',
    new: 'Черновик',
    waiting: 'В ожидании',
    rejected: 'Отклонена',
    accepted: 'Принята',
    approved: 'Утверждена',
    accept_inquiry: 'Принять запрос',
    successfully_accepted: 'Запрос успешно принят',
    send_inquiry: 'Отправить запрос',
    successfully_sent: 'Запрос успешно отправлен',
    received: 'Получена',
    canceled: 'Отменён',
    modifiedAndAccepted: 'Изменена/Принята',
    recovered: 'Восстановлена',
    create_new_application: 'Создать новую заявку',
    edit_application: 'Редактировать заявку',
    save_as_draft: 'Сохранить как черновик',
    send: 'Отправить',
    sent: 'Доставлено',
    inquiry_created_success: 'Запрос успешно создан',
    inquiry_sent_success: 'Запрос успешно отправлен',
    in_stock: 'В наличии',
    approved_quantity: 'Утвержденное количество',
    medicine_and_consumables: 'Лекарства и расходные материалы',
    needed_quantity: 'Требуемое количество',
    modified_quantity: 'Измененное количество',
    inquire_sent: 'Запрос отправлен',
    inquiry_number: 'Номер запроса',
    see_application_details: 'Посмотреть детали заявки',
    print: 'Распечатать',
    entry_date: 'Дата включения в учет',
    initiated_by: 'Инициировано',
    refused_by: 'Человек, который отклонил запрос',
    accepted_by: 'Человек, принявшее запрос',
    requested_to: 'Запрошено',
    institution_stock: 'Склад учреждения',
    local_stock: 'Локальный склад',
    issuance_based_on_inquire: 'Выдача на основе запроса',
    uploaded_documents: 'Документы',
    release: 'Выпуск',
    confirm: 'Подтвердить',
    medicine_requested: 'Запрошенные лекарства',
    medicine_to_release: 'Лекарства для выпуска',
    series: 'Серия',
    successfully_issued: 'Успешно выпущено',
    submit_medicine_for: 'Отправить лекарство для {{name}}',
    select_at_least_one_medicine: 'Выберите хотя бы одно лекарство',
    beneficiary: 'Бенефициар',
    rejected_success: 'Успешно отклонено',
    applicant: 'Заявитель',
    liberation_document: 'Документ о высвобождении',
    requested_medicine: 'Запрошенные лекарства и расходные материалы',
    medicine_consumables_to_release:
      'Лекарства и расходные материалы, подлежащие выпуску',
    to_release: 'Для выпуска',
    stock_issuance_create: 'Запрос на выпуск',
    confirm_send_title: 'Отправляете заявку?',
    confirm_send_desc: 'Вы уверены, что хотите отправить запрос?',
    invoice_date: 'Дата запроса',
    settlement_sent: 'Расчёт был отправлен'
  },
  stock_administration: {
    juridic_person: 'Юридическое лицо',
    add_new_input: 'Добавить новый ввод',
    entry_date: 'Дата включения в учет',
    total_stock: 'Общий запас',
    type: 'Тип',
    select_transport: 'Выберите транспорт',
    invoice_number: 'Номер счета',
    release_date: 'Дата выпуска',
    pickup_date: 'Дата забора',
    delivery_date: 'Дата доставки',
    way_bill: 'Накладная',
    institution_code: 'Код учреждения',
    register_transport: 'Зарегистрировать транспорт',
    manual_entry: 'Ручной ввод',
    price_unit: 'Цена за единицу (MDL)',
    price_total: 'Общая цена (MDL)',
    manual_entry_returns: 'Запись счета-фактуры на отгрузку',
    manual_entry_settlements: 'Акт подсчета',
    act_number: 'Номер акта',
    elaboration_date: 'Дата составления',
    record_incoming_invoice: 'Запись входящего счета',
    takeover_date: 'Дата взятия на учет',
    accept: 'Принять',
    accepted_success: 'Успешно принято',
    rejected_success: 'Успешно отклонено',
    reject: 'Отклонить',
    entry_added_success: 'Ввод успешно добавлен',
    add_issuance: 'Добавить выпуск',
    entry_form: 'Фармацевтическая форма',
    unit_price_with_tva: 'Стоимость за единицу с учетом НДС',
    total_amount: 'Итоговая сумма (MDL) с дополнительными затратами',
    product_details: 'Детали о продукте',
    send: 'Отправить',
    confirm: 'Подтвердить',
    restore: 'Восстановить'
  },
  stock_returns: {
    add_return: 'Добавить возврат',
    returned: 'Возвращено',
    return: 'Верните',
    create_new_return: 'Создать новый возврат',
    register_return_invoice: 'Регистрация счета на возврат',
    return_added_success: 'Заявка на возврат была успешно создана',
    stock_return: 'Возврат товара'
  },
  stock_write_offs: {
    add_new_write_off: 'Добавить новый акт списания',
    edit_write_off: 'Редактировать списание',
    write_off: 'Списание',
    register_number: 'Регистрационный номер',
    write_off_added_success: 'Акт списания успешно добавлен',
    registration_number: 'Регистрационный номер',
    current_quantity: 'Текущее количество',
    write_off_quantity: 'Количество списания',
    issuance_from: 'Расчеты из',
    issuance_to: 'До',
    initialized_by: 'Человек, который инициировал списание',
    processed_by: 'Человек, который обработал списание',
    restored_by: 'Человек, который восстановил списание'
  },
  stock_issuance: {
    issuance_from: 'Выдача из',
    issuance_to: 'До'
  },
  stock_local: {
    local_quantity: 'Количество на локальном складе'
  },
  stock_filters: {
    producer: 'Производитель',
    internationalName: 'Международное название',
    internationalNameId: 'Международное название',
    internationalNameIds: 'Международное название',
    states: 'Статус',
    productGroupIds: 'Группа',
    legalEntityIds: 'Юридические лица',
    roleIds: 'Роли',
    productGroupCategories: 'Категория склада'
  },
  errors: {
    size_error: 'Размер файла слишком большой',
    extension_error: 'Недопустимый тип файла',
    something_went_wrong: 'Что-то пошло не так',
    fill_at_least_one_field: 'Заполните хотя бы одно поле',
    quantity: 'Количество не может быть больше {{max}}',
    unitPrice: 'Цена за единицу не может быть больше {{max}}',
    release: 'Нельзя выдать больше, чем {{max}}'
  },
  analysis: {
    analysis: 'Анализ',
    date: 'Дата',
    analysis_type: 'Тип анализа',
    status: 'Статус',
    medic: 'Врач',
    analysed: 'Проанализировано',
    not_analysed: 'Не проанализировано',
    collection_date: 'Дата сбора',
    result_date: 'Дата результата',
    type: 'Тип теста',
    quantitative_test: 'Количественный тест',
    qualitative_test: 'Качественный тест',
    hiv_test: 'Результат ТРЛ HIV 1+2',
    result: 'Результат',
    institution: 'Учреждение',
    positive: 'Положительный',
    inconclusive: 'Неопределенный',
    negative: 'Отрицательный',
    medic_modal_title: 'Врач, заказавший тест',
    add_results: 'Добавить результаты',
    add_one_result: 'Добавить результат',
    add_test_and_result: 'Добавить тест и результат',
    save_test_only: 'Сохранить только тест',
    retry_save_result: 'Повторить сохранение результата',
    search_placeholder: 'Поиск по коду SIME',
    cancel_test: 'Отменить тест',
    cancel_test_reason: 'Причина отмены',
    cancel_test_comments: 'Комментарии к отмене',
    confirm_cancel_test: 'Вы уверены, что хотите отменить тест?',
    add_analysis: {
      add_analysis: 'Добавить анализ',
      automatic_analysis: 'Автоматическое добавление',
      manual_analysis: 'Ручное добавление',
      search_placeholder_analysis: 'Поиск по коду анализа',
      scan_code: 'Сканировать код',
      scan_code_placeholder: 'Введите код анализа',
      analysis_code: 'Код анализа',
      suply_code: 'Код поставки',
      middle_name: 'Отчество',
      birth_date: 'Дата рождения',
      speciment_type: 'Тип образца',
      address: 'Адрес',
      add_test: 'Добавить тест',
      save_analysis: 'Сохранить анализ',
      no_code_found: 'Не найдены записи по вашему запросу.',
      test_number: 'Номер теста',
      send_test_result: 'Отправить результат теста',
      test_sent: 'Тест отправлен'
    },
    add_test: {
      add_test: 'Добавить тест',
      test_date: 'Дата и время тестирования',
      bar_code: 'Штрих-код',
      a1: 'A1 (Первичное скрининговое тестирование)',
      a2: 'A2 (Вторичное скрининговое тестирование)',
      a3: 'A3 (Подтверждающий тест)',
      print_code: 'Распечатать код',
      consumable_materials: 'Наименование расходного материала',
      received_quantity: 'Полученное количество',
      add_consumable: 'Добавить продукт',
      save_test: 'Сохранить тест'
    }
  },
  cases: {
    placeholder: 'Поиск по коду SIME, населённому пункту',
    institution: 'Учреждение, которое уведомило',
    request_access: 'Запросить доступ к личным данным',
    send_request: 'Отправить запрос',
    request_reason: 'Причина запроса',
    primary_request_reason: 'Основная причина запроса',
    secondary_request_reason: 'Дополнительные причины запроса',
    new_patients: 'Добавлено {{count}} новых пациентов',
    new_cases: 'Новые случаи зарегистрированы в системе',
    add_case: 'Добавить случай',
    personal_data: 'Личные данные',
    epidemiological_number: 'Эпидемиологический номер',
    institution_code: 'Код учреждения',
    institution_address: 'Адрес учреждения:',
    residential_address: 'Адрес проживания',
    pregnant: 'Беременна?',
    was_in_prison: 'Была в тюрьме?',
    prison: 'Тюрьма',
    email_address: 'Адрес электронной почты',
    succes_send_request: 'Запрос был успешно отправлен',
    pre_test_counseling: 'Была дана консультация перед тестом',
    post_test_counseling: 'Была дана консультация после теста'
  },
  visits: {
    add_visitor: 'Добавить посетителя',
    visit_date: 'Дата визита',
    visitor_was_added: 'Посетитель был добавлен',
    visitor_was_added_description:
      'Посетитель был добавлен в ваш список визитов.',
    thanks: 'Спасибо',
    select_date: 'Выберите дату и время визита',
    current_date: 'Сегодняшняя дата',
    planned_visit_date: 'Дата запланированного визита'
  },
  transfers: {
    transfer_patient: 'Перевод пациента',
    transfer_patient_reason: 'Причина перевода',
    gender: 'Пол',
    print: 'Распечатать',
    modal_title: 'Перевод в другое медицинское учреждение',
    patient_personal_data: 'Личные данные пациента',
    idnp: 'Личный код (IDNP)',
    job: 'Место работы (должность), образование',
    submission: 'Направления:',
    consultation: 'На консультацию',
    investigation: 'На обследование',
    stationary: 'В стационар',
    ambulatory_condition: 'а) амбулаторное: заболевание',
    stationary_intern: 'б) стационар (Внутри)',
    stationary_extern: 'б) стационар (На выходе)',
    complete_diagnosis:
      'Полный диагноз (основное заболевание, сопутствующие осложнения)',
    complete_diagnosis_help:
      'Заполняется медицинскими учреждениями при направлении пациента на консультацию, обследование, госпитализацию, выписку (смерть) и предоставляется участковому врачу.',
    investigation_label:
      'Краткий анамнез, диагностические исследования, проведенное лечение, течение болезни, состояние здоровья при направлении, при выписке',
    recommendations: 'Лечебные и трудовые рекомендации',
    patient_belongs_medical_institution:
      'Медицинское учреждение, к которому принадлежит пациент',
    transferring_medical_institution:
      'Медицинское учреждение, в которое вы переводитесь'
  },
  liberations: {
    liberation_date: 'Дата освобождения/время'
  },
  reports_administration: {
    statistic_data: 'Статистические данные',
    assignee_report: 'Назначить отчет',
    about_report: 'О отчете',
    assignee_role: 'Назначение ролей',
    people_count: 'Общее количество людей',
    total_percentage: 'Процент от общего числа',
    age_0_14: '0-14 лет',
    age_15_24: '15-24 года',
    age_25_44: '25-44 года',
    age_45_64: '45-64 года',
    age_65: '65+ лет',
    men: 'Мужчины',
    women: 'Женщины',
    import_data: 'Импорт данных',
    result_title: 'Загруженный документ заменит данные!',
    add_report: 'Добавить отчет',
    edit_report: 'Редактировать отчет',
    type: {
      stocksEntries: 'Входы в склад',
      stocksInquiries: 'Запросы на склад'
    },
    report_created: 'Отчет был успешно создан',
    report_updated: 'Отчет был успешно обновлен',
    report_deleted: 'Отчет был успешно удален',
    delete_report: 'Вы уверены, что хотите удалить этот отчет?'
  },
  persons: {
    external_result: {
      title: 'Добавить внешний результат',
      edit_title: 'Редактировать внешний результат',
      add: 'Внешний результат',
      badge: 'Внешний источник',
      updated: 'Результат успешно обновлён',
      deleted: 'Результат успешно удалён',
      delete_confirm: 'Вы уверены, что хотите удалить этот внешний результат?',
      patient: 'Пациент',
      select_patient: 'Выберите пациента',
      select_patient_error: 'Выберите пациента',
      sample_collected_at: 'Дата взятия образца',
      result_date: 'Дата выдачи результата',
      received_at: 'Дата и время приёма',
      conformity: 'Соответствие образца',
      non_conformity_reason: 'Причина несоответствия',
      reception_not_saved:
        'Результат сохранён, но приём образца не удалось зарегистрировать',
      source_laboratory: 'Лаборатория-источник',
      source_laboratory_name: 'Название лаборатории-источника',
      source_registered: 'Из системы',
      source_free_text: 'Свободный текст'
    },
    prison_record: 'Тюремное досье',
    add_anonymous_person: 'Добавить анонимного человека',
    add_identified_person: 'Добавить идентифицированного человека',
    anonymous_register: 'Анонимная регистрация',
    identified_register: 'Идентифицированная регистрация',
    search_person: 'Поиск персон',
    person_management: 'Управление персоналом',
    idnp_name_surname_sime_code: 'IDNP, Имя, Фамилия, Код Симе или Код TESTRAP',
    add_new_person: 'Добавить нового человека',
    search_new_person: 'Найдите нового человека',
    from_date_of_birth: 'С даты рождения',
    to_date_of_birth: 'По дату рождения',
    with_idnp: 'По IDNP',
    search_persons: 'Поиск людей',
    with_personal_date: 'По личным данным',
    is_already_registered_person:
      'Этот человек уже зарегистрирован в другой больнице!',
    person_details: 'Детали человека',
    person_treatments: 'Лечение',
    person_screening: 'Исследование',
    person_investigations: 'Исследование',
    'person_investigation-results': 'Результаты исследований',
    personal_details_card: 'Личные данные',
    screening_investigation_card: 'Скрининг-исследование',
    treatment_card: 'Лечение',
    diagnostic_card: 'Диагноз',
    next_visit_card: 'Следующий визит',
    case_status_label: 'Статус случая',
    treatment_type_label: 'Тип лечения',
    start_date_label: 'Дата начала',
    end_date_label: 'Дата окончания',
    'person_epidemiology-cases': 'Эпидемиологические случаи и СПИД',
    person_visits: 'Посещения',
    person_recipes: 'Рецепт',
    person_pregnancy: 'Пренатальный мониторинг',
    person_pregnancy_details: 'Детали пренатального мониторинга',
    person_tutor: 'Опека',
    person_consultations: 'Консультации',
    'person_risk-groups': 'Группы риска',
    'person_sida-notification': 'Карта СПИД',
    person_history: 'История изменений',
    'person_preventive-treatment': 'Профилактическое лечение',
    'person_transfer-history': 'История переводов',
    person_diagnoses: 'Диагнозы',
    diagnoses_primary: 'Первичный диагноз',
    diagnoses_final: 'Окончательный диагноз',
    diagnoses_history: 'История диагнозов по консультациям',
    add_tutor_idnp: 'Назначить репетиторов (IDNP)',
    add_tutor_manual: 'Добавляйте репетиторов через личные данные',
    patient_transfer: 'Перевод пациента',
    assigned_persons: 'Назначенные лица',
    add_manual_person: 'Добавить человека вручную',
    patient_registered_successfully: 'Пациент успешно зарегистрирован',
    residence_address_same_current_address:
      'Адрес регистрации совпадает с адресом проживания',
    live_address_same_current_address:
      'Адрес проживания совпадает с адресом регистрации',
    add_person_success: 'Человек был успешно добавлен',
    alocate_doctor: 'Назначить врача',
    transfer: 'Перевод в другую медицинскую организацию',
    person_information: 'Информация о пациенте',
    save: 'Сохранить',
    investigated: 'Исследовано',
    notInvestigated: 'Неисследовано',
    no_tutor: 'Репетитор не требуется',
    child_tutor: 'Он человек под опекой (Ребенок)',
    parent_tutor: 'Репетитор (Родитель)',
    add_tutor: 'Добавить репетитора',
    no_person_found: 'Не найдено записей по вашему запросу.',
    exists_in_system: 'Этот человек уже есть в системе',
    delete_tutor: 'Вы уверены, что хотите удалить этого репетитора?',
    delete_penitentiary_record: 'Удалить запись о пенитенциарном учреждении?',
    delete_penitentiary_record_successfully:
      'Запись о пенитенциарном учреждении успешно удалена.',
    same_person_tutor_error: 'Репетитор не может быть тем же самым человеком',
    person_quiz: 'Вопросник',
    case_status: {
      title: 'Статус случая',
      possibleCase: 'Возможный случай',
      probableCase: 'Вероятный случай',
      confirmedCase: 'Подтверждённый случай'
    },
    register_as_patient: 'Зарегистрировать как пациента',
    allow_create_patient_account:
      'Диагностическое консультирование пациента для создания учетной записи пациента',
    create_patient_account: 'Создать аккаунт пациента',
    create_patient_account_success: 'Аккаунт пациента был создан успешно',
    assigned_doctors: 'Назначенные врачи',
    add_doctor: 'Добавить врача',
    delete_doctor: 'Врач был успешно удалён',
    select_dotor: 'Выберите врача',
    select_doctor_warning: 'Пожалуйста, выберите хотя бы одного врача',
    select_all_doctors: 'Выберите всех врачей',
    added_doctor_successfully: 'Врач был успешно добавлен',
    added_doctors_successfully: 'Врачи были успешно добавлены',
    investigations: {
      investigation_number: 'Иссследования №',
      investigation_new: 'Новое исследование',
      investigation_result: 'Результат исследования',
      investigation_date: 'Дата исследования',
      request_new_investigation: 'Запросить новое исследование',
      select_investigation_test_type: 'Выберите тип теста'
    },
    visits: {
      reserve_date: 'Запланируйте дату визита'
    },
    treatment: {
      treatment_number: 'Лечение №',
      start_date: 'Начало лечения',
      end_date: 'Дата следующего визита',
      prescribed_date: 'Дата назначения',
      treatment_prescribed: 'Назначенное лечение',
      treatment_administered: 'Проведенное лечение',
      start_date_invalid: 'Выберите корректную дату начала лечения.',
      end_date_invalid: 'Выберите корректную дату окончания лечения.',
      medicine_start_invalid:
        'Выберите корректную дату начала приема лекарства.',
      medicine_end_invalid:
        'Выберите корректную дату окончания приема лекарства.',
      prescribed_treatment_added: 'Назначенное лечение успешно добавлено',
      prescribed_treatment_updated: 'Назначенное лечение успешно обновлено',
      prescribed_treatment_deleted: 'Назначенное лечение успешно удалено',
      cannot_delete_administered:
        'Нельзя удалить препарат, который уже был применен',
      treatment_updated: 'Лечение успешно обновлено'
    },
    sime_tb_access: 'Доступ к лечению туберкулеза в Симе',
    notify_tb_new_case: 'Уведомить о новом случае ТБ',
    notify_tb_new_case_success: 'Новый случай ТБ успешно отправлен',
    sime_tb_treatments: 'Лечение туберкулеза',
    show_history: 'Показать историю изменений',
    history_modal_title: 'История изменений',
    create_patient_account_description:
      'Для создания аккаунта пациента, необходимо иметь основной диагноз.'
  },
  support_investigation: {
    add_org: 'Добавить организацию',
    select_placeholder: 'Выберите ассоциированную НПО',
    org_name: 'Название организации',
    people_count: 'Количество людей',
    add_people: 'Добавить людей',
    delete_org: 'Удалить организацию',
    upload_idnp: 'Загрузить IDNP из файла',
    not_analyzed: 'Не проанализировано'
  },
  recipes: {
    placeholder: 'IDNP, Имя, Фамилия или Код Сим',
    date_issued: 'Дата выдачи',
    date_dispensing: 'Дата выдачи',
    date_issued_asc: 'Дата выдачи (A - Z)',
    date_issued_desc: 'Дата выдачи (Z - A)',
    date_dispensing_asc: 'Дата выдачи (A - Z)',
    date_dispensing_desc: 'Дата выдачи (Z - A)',
    person_who_created_the_recipe: 'Лицо, создавшее рецепт',
    administred_treatment: 'Применение лечения',
    status: {
      new: 'Новый',
      dispensed: 'Выдано',
      declined: 'Отказано',
      cancelled: 'Отменено'
    },
    decline_confirm_title: 'Вы уверены, что хотите отклонить этот рецепт?',
    dispense_confirm_title: 'Вы уверены, что хотите выдать этот рецепт?',
    success_declined: 'Рецепт успешно отклонен',
    success_dispensed: 'Рецепт успешно выдан',
    patient_information: 'Информация о пациенте',
    commercial_name: 'Торговое наименование',
    requested_quantity: 'Запрашиваемое количество'
  },
  pregnancy_monitoring: {
    register_new_examination: 'Зарегистрировать новое обследование',
    national_clinical_protocol: 'Национальный клинический протокол',
    read_guide: 'Прочитать руководство',
    prompt_domain: 'Область подсказки',
    imsp_audit: 'Название IMSP, прошедшего аудит',
    uid: 'Уникальный идентификатор пациентки в информационной системе',
    responsible_person: 'Ответственное лицо за заполнение карты',
    medic: 'Лечащий врач',
    birth_date: 'Дата рождения пациентки',
    residency_medium: 'Среда проживания',
    urban: 'Городская',
    unknown: 'Неизвестно',
    rural: 'Сельская',
    dispensary_record: 'Диспансерный учет',
    diagnosis_date: 'Дата установления диагноза ВИЧ',
    probable_route_of_infection: 'Вероятный путь заражения',
    registration_date:
      'Дата постановки на диспансерный учет (согласно регистру учета пациентов с ВИЧ)',
    diagnosis: 'Диагноз',
    hiv_rna_level: 'Был определен уровень РНК ВИЧ на 36 неделях беременности?',
    hiv_rna_level_ml: 'Уровень РНК ВИЧ, копии/мл',
    undetermined: 'Неопределено',
    lower_50: '<50',
    between_50_1000: '50 - 1000',
    greater_1000: '1000+',
    hiv_rna_level_date: 'Дата определения уровня РНК ВИЧ',
    treatment: 'Лечение',
    arv_treatment_initiated: 'Начато ли ARV лечение (в том числе при родах)?',
    no_patient_refused: 'Нет, отказ пациентки',
    no_other_reasons: 'Нет, другие причины',
    azt_treatment_at_birth: 'Был ли предложен AZT во время родов?',
    initiated_treatment_date: 'Когда было начато лечение?',
    children_birth_date: 'Дата рождения детей',
    was_interruptions_in_art: 'Были ли перерывы в ART?',
    mode_of_birth: 'Способ родов',
    physiological: 'Физиологические',
    caesarean_operation: 'Кесарево сечение',
    was_on_art_during_delivery: 'Было ли ART во время родов?',
    number_of_children_born: 'Количество рожденных детей',
    number_of_children_born_alive: 'Количество живорожденных детей',
    initiation_date_of_last_tar: 'Дата начала последнего ART до родов',
    evaluation_date: 'Дата оценки',
    add: 'Добавить обследование'
  },
  restricted_access: {
    title: 'Извините, у вас нет прав доступа к этой странице.',
    back_home: 'Вернуться на главную'
  },
  counterparts: {
    title: 'Контрагент',
    add_counterpart: 'Добавить нового поставщика',
    producer_name: 'Поставщик услуг',
    contract_number: '№ Контракта',
    active_from: 'Активен с',
    active_to: 'Активен до',
    status: 'Статус',
    active: 'Активен',
    inactive: 'Неактивен',
    counter_part_deleted: 'Контрагент успешно удален',
    delete_counterpart: 'Вы уверены, что хотите удалить этого контрагента?',
    provider_created: 'Контрагент успешно создан',
    no_contracts_found: 'Нет ни одного контракта.',
    add_new_contract: 'Добавить новый контракт',
    add_new_template_contract: 'Сохранить как шаблон',
    contracts: 'Контракты',
    draft: 'Шаблоны контрактов',
    template_name: 'Название шаблона',
    template_description: 'Описание шаблона',
    template_created: 'Шаблон успешно создан',
    template_updated: 'Шаблон успешно обновлен',
    template_deleted: 'Шаблон успешно удален',
    contact_created: 'Контакт успешно создан',
    provider: 'Поставщик',
    purchase_center: 'Получатель',
    distributor: 'Дистрибьютор',
    signed_date: 'Дата подписания контракта',
    contract_start_date: 'Дата вступления контракта в силу',
    contract_end_date: 'Дата окончания контракта',
    intern_number: 'Внутренний номер / Управление',
    additional_files: 'Дополнительные файлы',
    description: 'Описание',
    contact_deleted: 'Контракт успешно удален',
    delete_contract: 'Удалить договор?',
    sort_contract_by_number: 'Нет. Контракт (увеличение)',
    sort_contract_by_number_desc: 'Нет. Контракт (уменьшение)',
    sort_contract_by_date: 'Дата активации (по возрастанию)',
    sort_contract_by_date_desc: 'Дата активации (по убыванию)',
    sort_contract_by_end_date: 'Дата окончания (по возрастанию)',
    sort_contract_by_end_date_desc: 'Дата окончания (по убыванию)',
    add_product: 'Добавить продукт',
    quantity: 'Количество',
    delivered_quantity: 'Количество доставленное',
    outstanding_quantity: 'Количество оставшееся'
  },
  medicine_register: {
    title: 'Реестр Лекарств и Расходных Материалов',
    upload_medicines: 'Загрузить лекарства',
    provider: 'Поставщик',
    upload_error: 'Пожалуйста, загрузите документ',
    count: 'Кол-во элементов',
    products: {
      title: 'Лекарства',
      description:
        'Название, под которым лекарство известно и продается. Это может быть торговая марка или генерическое название, важное для правильного распознавания и назначения.',
      delete: 'Вы уверены, что хотите удалить это лекарство?',
      delete_success: 'Лекарство успешно удалено',
      add: 'Добавить торговое наименование',
      prescription: 'Рецепт',
      dose: 'Доза',
      volume: 'Объем',
      division: 'Разделение',
      validity_period: 'Срок годности (месяцы)',
      name: 'Название'
    },
    international_name: {
      title: 'Международное Наименование',
      description:
        'Международно признанное название (обычно МНН – Международное Непатентованное Наименование), которое определяет активное вещество лекарства и стандартизировано для глобального использования.',
      all: 'Все',
      only_used: 'Только использованные',
      only_not_used: 'Только не использованные',
      delete: 'Вы уверены, что хотите удалить это международное наименование?',
      delete_success: 'Международное наименование успешно удалено',
      name: 'Международное наименование',
      add_name: 'Добавить международное наименование',
      edit_name: 'Редактировать международное наименование',
      is_used: 'Используется'
    },
    pharmaceutical_form: {
      title: 'Фармацевтическая Форма',
      description:
        'Физическая форма представления лекарства, такая как таблетка, капсула, инъекционная жидкость, сироп, мазь и т.д., предназначенная для правильного применения и терапевтической эффективности.',
      delete: 'Вы уверены, что хотите удалить эту фармацевтическую форму?',
      delete_success: 'Фармацевтическая форма успешно удалена',
      add_form: 'Добавить фармацевтическую форму',
      edit_form: 'Редактировать фармацевтическую форму'
    },
    producers: {
      title: 'Производственная Компания',
      description:
        'Название компании или организации, которая производит лекарство и несет ответственность за соблюдение стандартов качества и безопасности.',
      delete: 'Вы уверены, что хотите удалить эту компанию?',
      delete_success: 'Компания успешно удалена',
      add_company: 'Добавить производственную компанию',
      edit_company: 'Редактировать производственную компанию',
      name: 'Производственная компания'
    },
    consumables: {
      title: 'Расходные материалы',
      add: 'Добавить расходный материал',
      delete: 'Вы уверены, что хотите удалить этот расходный материал?',
      delete_success: 'Расходный материал успешно удален',
      measurement_unit: 'Единица измерения',
      unit_size: 'Размер единицы',
      unit_count: 'Количество'
    },
    units: {
      title: 'Единицы измерения',
      add_unit: 'Добавить единицу измерения',
      edit_unit: 'Редактировать единицу измерения',
      delete: 'Вы уверены, что хотите удалить эту единицу измерения?',
      delete_success: 'Единица измерения успешно удалена',
      name: 'Название'
    }
  },
  pre_screening: {
    document_number_asc: 'Номер документа (по возрастанию)',
    document_number_desc: 'Номер документа (по убыванию)',
    add_new_people: 'Добавить людей',
    sent_to_ong: 'Отправить список в НПО',
    delete_list_title: 'Вы уверены, что хотите удалить этот список?',
    ong: 'НПО',
    document_number: 'Номер документа',
    person_count: 'Количество людей',
    new: 'Новый',
    pre_screening: 'Предварительная проверка',
    sent: 'Предварительная проверка',
    not_found: 'Nu a fost găsit',
    add_new_list: 'Создать новый список',
    document_date: 'Дата документа',
    edit_list: 'Редактировать список',
    sent_to_ong_confirm: 'Вы уверены, что хотите отправить этот список в НПО?',
    finished_screening: 'Прошел предварительный отбор',
    not_found_screening: 'Не найдено',
    screening_date: 'Дата скрининга',
    person_registered_from: 'Зарегистрирован в системе по',
    person_group: 'Группа населения (категория)',
    screening_day: 'Дата дня скрининга'
  },
  qr_code: {
    scan_qr_code: 'Сканировать QR код',
    scan_code: 'Сканируйте код',
    enter_code_manually: 'Ввести код вручную',
    invalid_code: 'Этот код недействителен',
    required_permission:
      'У вас нет необходимых прав для выполнения этого действия',
    unsupported_qr_type: 'Этот тип QR-кода не поддерживается',
    view_qr_code: 'Просмотреть QR код'
  },
  tests: {
    created_from_date: 'С даты создания',
    created_to_date: 'До даты создания',
    add_test: 'Добавить пробу',
    test_datetime: 'Дата/время тестирования',
    code: 'Код пробы',
    result_datetime: 'Дата/время результата',
    statuses: {
      created: 'Создано',
      harvested: 'Собрано',
      inProgress: 'В процессе',
      canceled: 'Отменено',
      completed: 'Завершено',
      rejected: 'Отклонено'
    },
    laboratory_statuses: {
      received: 'Принято',
      inconform: 'Не соответствует',
      sentToValidation: 'Отправлено на проверку',
      validated: 'Принято',
      rejected: 'Отклонено'
    },
    testDone: 'Принято'
  },
  tb_screening: {
    title: 'Скрининг на ТБ (при каждом визите)',
    subtitle:
      'Проверьте симптомы ТБ и недавний контакт с больным ТБ. Любой ответ «Да» требует обследования на активный ТБ.',
    cough: 'Кашель',
    fever: 'Лихорадка',
    weight_loss: 'Потеря веса',
    night_sweats: 'Ночная потливость',
    recent_tb_contact: 'Недавний контакт с больным ТБ',
    is_hospitalized: 'Госпитализированный пациент',
    positive_alert:
      'Скрининг на ТБ положительный — пациенту необходимо обследование на активный ТБ',
    recommended: 'Рекомендуемые обследования:',
    rec_crp: 'С-реактивный белок (значение > 5 мг/л указывает на ТБ)',
    rec_xray: 'Рентгенография грудной клетки',
    rec_lf_lam: 'LF-LAM Ag (CD4 < {{threshold}} клеток/мкл)',
    rec_xpert: 'Xpert MTB/RIF',
    rec_phthisiatrician: 'Консультация фтизиатра (направление)',
    lf_lam_recommended:
      'Рекомендуется: последний CD4 = {{value}} клеток/мкл ({{date}})',
    lf_lam_not_required:
      'Последний CD4 = {{value}} клеток/мкл ({{date}}) — выше порога {{threshold}}',
    cd4_unknown: 'В системе нет результата CD4',
    request_lab: 'Запросить лабораторные исследования на ТБ',
    workup_title: 'Обследование на активный ТБ',
    crp: 'С-реактивный белок (мг/л)',
    crp_above: 'Выше 5 мг/л — указывает на ТБ',
    crp_date: 'Дата СРБ',
    chest_xray: 'Рентгенография грудной клетки',
    chest_xray_date: 'Дата рентгенографии',
    lf_lam: 'LF-LAM Ag',
    lf_lam_date: 'Дата LF-LAM',
    xpert: 'Xpert MTB/RIF',
    xpert_date: 'Дата Xpert MTB/RIF',
    referral: 'Направлен на консультацию фтизиатра',
    referral_date: 'Дата направления',
    referral_notes: 'Примечания для фтизиатра',
    tb_positive_alert:
      'ТБ подтверждён — после сохранения направьте пациента в SIME TB («Уведомить о новом случае ТБ» на странице пациента).',
    not_done: 'Не проводилось',
    chest_xray_result: {
      normal: 'Норма',
      suggestiveOfTb: 'Указывает на ТБ'
    },
    test_result: {
      positive: 'Положительный',
      negative: 'Отрицательный'
    },
    xpert_result: {
      mtbNotDetected: 'МБТ не обнаружены',
      detectedRifSensitive: 'МБТ обнаружены, RIF чувствительность',
      detectedRifResistant: 'МБТ обнаружены, RIF устойчивость',
      detectedRifIndeterminate: 'МБТ обнаружены, RIF не определена',
      invalid: 'Недействительный / ошибка'
    },
    screening_negative: 'Скрининг на ТБ отрицательный',
    screening_positive: 'Скрининг на ТБ положительный',
    active_scheme_title: 'Активная схема лечения ТБ (SIME TB)',
    active_scheme_none: 'В SIME TB нет активной схемы лечения ТБ',
    active_scheme_start: 'Дата начала',
    active_scheme_regimen: 'Схема'
  },
  consultations: {
    new_consultation: 'Новая консультация',
    add_new_consultation: 'Добавить новую консультацию',
    institution_name_asc: 'Название учреждения (A - Я)',
    institution_name_desc: 'Название учреждения (Я - A)',
    consultation_type_asc: 'Тип консультации (A - Я)',
    consultation_type_desc: 'Тип консультации (Я - A)',
    search_placeholder: 'Поиск по названию учреждения',
    consultation_type: 'Тип консультации',
    status: {
      scheduled: 'Запланирована',
      present: 'Присутствует',
      absent: 'Отсутствует'
    },
    personStatus: {
      scheduled: 'Предстоящее',
      present: 'Завершено',
      absent: 'Отсутствует'
    },
    register_new_consultation: 'Зарегистрировать новую консультацию',
    get_latest_info: 'Получить данные из предыдущей консультации',
    consultation_date: 'Дата консультации',
    pregnant_women: 'Беременная женщина',
    delete_consultation: 'Вы уверены, что хотите удалить эту консультацию?',
    success_delete_consultation: 'Консультация была успешно удалена',
    reschedule_consultation: 'Перепланировать консультацию',
    manage_consultation: 'Управление консультацией',
    edit_consultation: 'Редактировать консультацию',
    success_update: 'Консультация успешно обновлена',
    edit_until_end_of_day:
      'Консультацию можете редактировать только вы и только сегодня, до 23:59.',
    edit_period_expired:
      'Консультацию больше нельзя редактировать: только автор, в день проведения (до 23:59).',
    treatment_plan_read_only:
      'Существующий план лечения не изменяется при редактировании консультации.',
    success_create: 'Консультация была успешно создана',
    save_as_draft: 'Сохранить как черновик',
    draft: 'Черновик',
    draft_saved: 'Черновик успешно сохранён',
    draft_updated: 'Черновик успешно обновлён',
    autosave_session_expiring: 'Сессия скоро истечёт',
    autosave_draft_saved:
      'Консультация была автоматически сохранена как черновик до истечения сессии.',
    from_draft: 'Из черновика',
    draft_name: 'Название черновика',
    draft_description: 'Описание черновика',
    select_draft: 'Выберите черновик',
    no_drafts: 'Нет сохранённых черновиков',
    draft_deleted: 'Черновик успешно удалён',
    schedule_consultation: 'Запланировать консультацию',
    schedule_new_consultation: 'Запланировать новую консультацию',
    select_date_and_time: 'Выберите дату и время консультации',
    consultation_scheduled_successfully:
      'Консультация была успешно запланирована',
    consultation_rescheduled_successfully:
      'Консультация была успешно перепланирована',
    select_options:
      'Выберите опции, которые должны быть включены в эту консультацию:',
    preliminary_information: 'Предварительная информация',
    epidemiological_case: 'Эпидемиологический случай',
    treatment: 'Лечение',
    add_new_treatment: 'Добавить новое лечение',
    active_substance: 'Действующее вещество',
    dose: 'Доза',
    duration_days: 'Продолжительность (дни)',
    recipes: 'Рецепты',
    add_new_recipe: 'Добавить новый рецепт',
    report_adverse_reaction: 'Сообщить о побочной реакции',
    add_person_as_pacient:
      'Одновременно с записью на консультацию вы также создаете учетную запись пациента в системе.',
    adverse_reaction_date: 'Дата возникновения побочной реакции',
    accuse: 'Обвинение',
    daily_quantity: 'Количество (в день)',
    preliminary_diagnostic: 'Предварительный диагноз',
    preliminary_notes_placeholder:
      'Добавьте заметки, такие как анамнез, состояние пациента и т. д.',
    investigation_request: 'Запрос на исследование',
    new_investigation_request: 'Запрос на новое исследование',
    tb_investigations: 'Исследования ТБ',
    new_tb_investigation_request: 'Запрос на новое исследование ТБ',
    direction_to: 'Направление к',
    select_laboratory: 'Выберите лабораторию',
    investigation_created_successfully:
      'Запрос на исследование был успешно создан',
    previous_tests: 'Предыдущие тесты',
    harvest_date: 'Дата тестирования',
    final_diagnostic: 'Диагноз',
    aids_clinical_category: '55.2. Клиническая категория СПИДа',
    aids_clinical_category_required:
      'Клиническая категория СПИДа обязательна при диагнозе ВИЧ-инфекции (B20–B24, Z21)',
    aids_clinical_category_hint:
      'Обязательно при диагнозе ВИЧ-инфекции (B20–B24, Z21)',
    aids_clinical_conditions: 'Клинические состояния – категория {{category}}',
    aids_clinical_conditions_hint:
      'Категория C остаётся окончательной после её появления; заболевания категории B имеют приоритет над категорией A.',
    cd4_count_latest: 'CD4: {{count}} кл/мкл ({{date}})',
    cd4_percent_latest: 'CD4%: {{percent}}% ({{date}})',
    cd4_no_results: 'CD4: нет результатов',
    cd4_suggested_category:
      'Предлагаемая категория CD4: {{category}} ({{range}})',
    recipe_number: '№ рецепта',
    recipe_date: 'Дата рецепта',
    new_recipe: 'Новый',
    dispensed_recipe: 'Рецепт выдан',
    cancelled_recipe: 'Отменено',
    refused_recipe: 'Отказано',
    add_new_recipe_title: 'Добавить новый рецепт',
    preparation_name: 'Название рецепта',
    recipe_added_successful: 'Рецепт был добавлен успешно',
    specimen_type: 'Тип образца',
    specimen: 'Образец',
    add_specimen: 'Добавить образец',
    add_institution: 'Добавить учреждение',
    select_specimen_type: 'Выберите тип образца',
    contacts: 'Контакты',
    contacts_add: 'Добавить контакты',
    contacts_exists: 'Уже есть в контактах',
    contacts_add_self_error: 'Вы не можете добавить себя в контакты',
    examination: 'Первичная / вторичная'
  },
  investigations: {
    search_placeholder: 'Поиск по № расследования',
    created_date: 'Дата создания',
    performed_datetime: 'Дата и время проведения',
    performed_date: 'Дата проведения',
    harvest_date: 'Дата и время сбора',
    investigation_number: '№ расследования',
    categories: 'Категории',
    category: 'Категория',
    investigation_reason: 'Причина исследования',
    anonymous: 'Аноним',
    no_investigations: 'Нет исследований',
    assign_investigation_demand: 'Назначьте пробу',
    select_harvest_date_and_time: 'Выберите дату и время сбора',
    success_assigned_investigation: 'Проба успешно назначена',
    close: 'Закрыть',
    investigation_details: 'Детали расследования',
    cancel_investigation: 'Отмена расследования',
    cancellation_reason: 'Причина отмены расследования',
    treatment_reason: 'Причина лечения',
    cancellation_comments: 'Ваши комментарии',
    investigation_cancelled_successfully: 'Расследование успешно отменено',
    investigation: 'Проба',
    investigation_code: 'Код пробы',
    tests: 'Тесты',
    laboratory_tehnic: 'Лабораторный техник:',
    test_created_successfully: 'Тест был успешно создан',
    test_number: '№ тест',
    test_details: 'Детали теста',
    registration_number: 'Номер регистрации',
    successfully_added_result: 'Результат был успешно добавлен',
    cantitative_test: 'Количественный тест',
    xpert: 'Xpert VL HIV-1',
    other: 'Другие (название)',
    hiv1: 'ВИЧ-1',
    hiv1_suffix: 'копии/мл',
    hiv1_placeholder: '№ копий/мл',
    calitative_test: 'Качественный тест',
    hiv1_detected: 'ВИЧ-1 обнаружен',
    hiv1_undetected: 'ВИЧ-1 не обнаружен',
    hiv2: 'ВИЧ-2',
    trd_result: 'Результат TRD ВИЧ-1/2 (название)',
    trd_result_placeholder: 'Введите название теста',
    xpert_qual: 'Xpert Qual HIV-1',
    successfully_send_result: 'Результат был успешно отправлен',
    approved_date: 'Дата утверждения',
    approved_by: 'Утверждено врачом',
    search_by_code: 'Поиск по коду образца',
    not_found_investigation: 'Не найдено ни одного образца для введенного кода',
    add_person: 'Добавить человека',
    search_by_person_code: 'Поиск по коду SIME, коду TARV',
    want_to_cancel_investigation: 'Вы хотите отменить пробу?',
    add_at_least_one_result: 'Добавьте хотя бы один результат',
    stock_quantity: 'Количество на складе',
    insufficient_quantity_stock: 'Недостаточное количество на складе',
    person_error: 'Необходимо назначить человека на образец',
    conform: 'Соответствует',
    not_conform: 'Не соответствует',
    reception_date: 'Дата и время приема',
    investigation_reception: 'Прием образца',
    reception: 'Прием',
    investigation_status: 'Статус образца',
    validate: 'Проверка',
    reject: 'Отклонение',
    validate_investigation: 'Принятие образца',
    validate_investigation_success: 'Образец успешно принят',
    reject_investigation: 'Отклонение образца',
    reject_investigation_success: 'Образец успешно отклонен',
    reject_reason: 'Причина отклонения',
    internal_code: 'Внутренний код',
    approved: 'Утверждено',
    view_results: 'Просмотр результатов',
    result_value: 'Значение результата',
    result_numeric_value: 'Числовое значение результата',
    tested_at: 'Диагноз',
    send_to_validation: 'Отправить тест на проверку',
    send_all: 'Отправить все результаты',
    successfully_send_to_validation: 'Тест успешно отправлен на проверку',
    successfully_rejected_test: 'Тест успешно отклонен',
    reject_test: 'Отклонить тест',
    select_category: 'Выберите исследования от текущего учреждения',
    select_category_from_other_institutions:
      'Выберите исследования от других учреждений',
    sent_to_laboratory_at: 'Отправлен в лабораторию в',
    temperature: 'Температура пробы при приемке',
    reject_test_result: 'Отклонить результат теста',
    referral_doctor: 'Врач, направивший пациента',
    referral_doctor_name: 'Имя врача, направившего пациента',
    referral_doctor_registered: 'Из системы',
    referral_doctor_free_text: 'Свободный текст'
  },
  questionnaires: {
    search_by_title: 'Поиск по названию',
    questions_count: 'Количество вопросов',
    move_to_draft: 'Переместить в черновик',
    create_copy: 'Создать копию',
    publish: 'Опубликовать',
    questionnaire_title: 'Название анкеты',
    question: 'Вопрос',
    preview: 'Предварительный просмотр',
    draft: 'Черновик',
    active: 'Активно',
    inactive: 'Неопубликовано',
    create_new_questionnaire: 'Создать новую анкету',
    edit_questionnaire: 'Редактировать анкету',
    questionnaire_desc: 'Описание анкеты',
    questions: 'Вопросы',
    answers: 'Ответы',
    question_type: 'Tipul de intrebare',
    add_question: 'Добавить вопрос',
    add_option: 'Добавить вариант',
    delete_question: 'Вы уверены, что хотите удалить этот вопрос?',
    delete_option: 'Вы уверены, что хотите удалить этот вариант?',
    singleChoice: 'Один ответ',
    multipleChoice: 'Несколько ответов',
    persons: 'чел.',
    persons_count_completed_questionnaire: 'Заполнили анкету',
    no_person_completed_this_questionnaire: 'Никто не заполнил эту анкету',
    back_to_edit: 'Назад к редактированию',
    quiz_shared: 'Распределенные анкеты',
    quiz_not_shared: 'Нераспространенные анкеты',
    cannot_share_quiz_with_no_questions:
      'Нельзя распределить анкету без вопросов',
    quiz_has_no_answers: 'Анкета не имеет ответов',
    answered: 'Ответил',
    notAnswered: 'Не ответил',
    completed: 'Заполненная форма',
    not_completed: 'Для заполнения',
    has_free_text: 'Есть свободный текст?'
  },
  pregnancy: {
    pregnancy: 'Пренатальный мониторинг',
    age: 'Возраст беременности',
    last_gestation_date: 'Дата последней менструации (DUM)',
    estimated_birth_date: 'Дата ожидаемого рождения (DEN)',
    pregnancy_type: 'Тип беременности',
    pregnancy_status: 'Статус беременности',
    pregnancy_localization: 'Локализация беременности',
    registration_date: 'Дата регистрации',
    DUM: 'DUM',
    DEN: 'DEN',
    interrupted: 'Прервана',
    completed: 'Завершена',
    inProgress: 'В мониторизации',
    monitoring_period: 'Период мониторизации',
    monitoring_test: 'Тест мониторизации беременности',
    pregnant_localization_status: {
      intrauterine: 'Внутриутробный',
      extrauterine: 'Внематочная'
    },
    interrupted_pregnancy_reason: 'Причина прерывания беременности',
    pregnancy_type_status: {
      singular: 'Одиночная',
      multiple: 'Множественная'
    },
    pregnancy_actions_statuses: {
      cesareanSection: 'Кесарево сечение',
      interruptedPregnancy: 'Прерванная беременность',
      pregnantPerson: 'Беременное лицо',
      lostPregnancy: 'Потерянная беременность',
      naturalBirth: 'Естественные роды'
    },
    interrupted_pregnancy_reasons: {
      highRiskForMotherHealth: 'Высокий риск для здоровья матери',
      severeChildCongenitalMalformation:
        'Тяжелая врожденная патология у ребенка',
      otherMedicalReasons: 'Другие медицинские причины'
    },
    investigation_limit_date: 'Дата окончания исследования',
    newBorns: 'Новорожденные',
    newBorns_investigations: 'Исследования новорожденных',
    births: 'Рождения',
    birth_type_status: 'Тип родов',
    birth_type: {
      natural: 'Естественные роды',
      unknown: 'Неизвестно',
      cesareanSection: 'Кесарево сечение'
    },
    period_type_status: 'Тип периода',
    period_type: {
      fullTermPregnancy: 'Полноценная беременность',
      premature: 'Преждевременная беременность'
    },
    add_new_birth: 'Добавить новое рождение',
    view_new_birth: 'Просмотр рождения',
    add_newborn: 'Добавить нового новорожденного',
    feeding_type: 'Тип кормления',
    feeding_types: {
      natural: 'Естественное',
      artificial: 'Искусственное'
    },
    newborn_status: 'Статус новорожденного',
    newborn_statuses: {
      healthy: 'Здоровый',
      hiv: 'ВИЧ-положительный',
      deceased: 'Умерший'
    },
    current_weight: 'Текущий вес (кг)',
    current_height: 'Текущий рост (см)',
    birth_date_from: 'Дата рождения от',
    birth_date_to: 'Дата рождения до',
    add_pregnancy: 'Добавить беременность',
    investigation_status: {
      toDo: 'Необходимо провести',
      inProgress: 'В процессе',
      expired: 'Просрочено',
      completed: 'Завершено',
      needToInvestigate: 'Необходимо провести'
    },
    period_status: {
      initial: 'Начальный',
      optional: 'Необязательный',
      for28Weeks: 'Для 28 недель',
      for36Weeks: 'Для 36 недель'
    },
    newborn_period_status: {
      atFortyEightHours: 'Через 48 часов',
      atSixToEightWeeks: 'Через 6-8 недель',
      atNineMonths: 'Через 9 месяцев'
    },
    newborn_investigations_tabs: {
      status: 'Статус исследований',
      demands: 'Направления на исследования'
    },
    newborn_investigation_status: {
      child: 'Ребенок',
      mother: 'Мать',
      completeness: 'Полнота',
      complete: 'Полный',
      incomplete: 'Неполный',
      missing_count: 'Просроченные периоды без результата: {{count}}',
      only_incomplete: 'Только неполные',
      search_placeholder: 'Поиск по ребенку или матери',
      due_date: 'Срок',
      result_date: 'Дата результата',
      result: 'Результат',
      demand: 'Направление',
      states: {
        done: 'Результат есть',
        requested: 'Направлено – без результата',
        missing: 'Отсутствует',
        planned: 'Запланировано'
      }
    },
    newborn_plan_result: {
      present: 'Результат есть',
      absent: 'Без результата'
    },
    pregnancy_created_successfully: 'Беременность успешно добавлена',
    pregnancy_edit_successfully: 'Беременность успешно изменена',
    at_least_one_newborn: 'Необходимо добавить хотя бы одного новорожденного',
    birth_created_successfully: 'Рождение успешно добавлено',
    sorting_options: {
      registration_date_asc: 'Дата регистрации (A - Z)',
      registration_date_desc: 'Дата регистрации (Z - A)',
      last_gestation_date_asc: 'Дата последней менструации (DUM) (A - Z)',
      last_gestation_date_desc: 'Дата последней менструации (DUM) (Z - A)',
      gestational_age_in_weeks_asc: 'Возраст беременности (недели) (A - Z)',
      gestational_age_in_weeks_desc: 'Возраст беременности (недели) (Z - A)',
      pregnancy_type_asc: 'Тип беременности (A - Z)',
      pregnancy_type_desc: 'Тип беременности (Z - A)',
      expected_date_of_birth_asc: 'Дата ожидаемого рождения (DEN) (A - Z)',
      expected_date_of_birth_desc: 'Дата ожидаемого рождения (DEN) (Z - A)'
    },
    isPregnancyMonitoring: 'Пренатальный мониторинг',
    isNewborn: 'Новорожденные'
  },
  sida_notification: {
    title: 'Карта установления стадии СПИД',
    add: 'Добавить карту СПИД',
    view: 'Просмотр карты СПИД',
    patient_identification: 'Данные идентификации пациента',
    idnp: 'IDNP',
    full_name: 'Имя и Фамилия',
    patronymic: 'Отчество',
    epidemiology_number: 'Эпидемиологический номер',
    birth_date: 'Дата рождения',
    gender: 'Пол',
    current_address: 'Адрес текущего места жительства',
    sida_diagnosis: 'Данные диагностики СПИД',
    sida_stage_date: 'Дата установления стадии СПИД',
    sida_stage_reason: 'Причина установления стадии СПИД',
    sida_reason_indicator_disease:
      'СПИД-индикаторное заболевание (оппортунистические инфекции)',
    sida_reason_cd4: 'Низкие значения маркера CD4',
    sida_reason_both: 'СПИД-индикаторное заболевание и низкие значения CD4',
    arv_treatment_at_diagnosis:
      'АРВ-терапия на момент установления диагноза СПИД',
    statistics_report_date: 'Дата отчётности в статистику стадии СПИД',
    medical_personnel: 'Идентификация медицинского персонала',
    doctor_name: 'Имя и фамилия врача',
    doctor_function: 'Должность врача',
    save: 'Сохранить',
    success_create: 'Карта СПИД успешно создана',
    success_update: 'Карта СПИД успешно обновлена',
    already_exists: 'Карта СПИД уже создана для этого пациента',
    confirm_save: 'Подтвердить сохранение карты СПИД?',
    yes: 'Да',
    no: 'Нет',
    created_at: 'Дата создания',
    male: 'Мужской',
    female: 'Женский',
    no_case: 'Карта СПИД для данного пациента не найдена'
  },
  demographics: {
    yes: 'Да',
    no: 'Нет',
    title: 'Демографические данные',
    patronymic: 'Отчество',
    maritalStatus: 'Семейное положение',
    vitalStatus: 'Жизненный статус',
    deathDate: 'Дата смерти',
    deathCause: 'Причина смерти',
    leftCountryDate: 'Дата выезда из страны',
    leftCountry: 'Выехал из страны',
    leftCountryType: 'Тип выезда',
    arrivedFromAbroadDate: 'Дата приезда из другой страны',
    arrivedFromCountry: 'Страна происхождения',
    marital_status: {
      married: 'В браке',
      cohabiting: 'Гражданский брак',
      widowed: 'Вдовец / вдова',
      single: 'Холост / не замужем',
      divorced: 'В разводе',
      notApplicableChild: 'Не применимо (ребёнок)'
    },
    vital_status: {
      alive: 'Жив(а)',
      deceased: 'Умер(ла)'
    },
    death_cause: {
      aidsRelated: 'Связана со СПИД',
      notAidsRelated: 'Не связана со СПИД',
      unknown: 'Неизвестна'
    },
    left_country_type: {
      temporary: 'Временно',
      permanent: 'Навсегда'
    },
    left_country_type_required: 'Выберите тип выезда',
    arrived_together: 'Дата приезда и страна происхождения заполняются вместе',
    arrived_not_home: 'Страной происхождения не может быть Республика Молдова'
  },
  hiv_anamnesis: {
    title: 'Карта эпидемиологического анамнеза случая ВИЧ-инфекции',
    full_title: 'Карта эпидемиологического анамнеза случая ВИЧ-инфекции',
    add: 'Добавить карту эпидемиологического анамнеза',
    view: 'Карта эпидемиологического анамнеза случая ВИЧ-инфекции',
    no_case: 'Для этого пациента нет карты эпидемиологического анамнеза',
    draft_hint:
      'Форму можно сохранить как черновик в любой момент. При завершении проверяются все обязательные поля; завершённая форма остаётся редактируемой, но каждое сохранение проверяется.',
    save_draft: 'Сохранить черновик',
    complete: 'Завершить',
    save: 'Сохранить',
    confirm_draft: 'Сохранить форму как черновик?',
    confirm_complete: 'Завершить карту эпидемиологического анамнеза?',
    confirm_save: 'Сохранить изменения карты эпидемиологического анамнеза?',
    success_draft: 'Черновик карты эпидемиологического анамнеза сохранён',
    success_complete: 'Карта эпидемиологического анамнеза сохранена',
    status_label: 'Статус',
    status: {
      draft: 'Черновик',
      completed: 'Завершена'
    },
    anonymous_identifier: 'Анонимный идентификатор',
    created_at: 'Дата создания',
    updated_at: 'Дата изменения',
    completed_at: 'Дата завершения',
    no_personal_data_title: 'Персональные данные скрыты',
    no_personal_data_description:
      'У вас нет доступа к персональным данным пациента. Фамилия, имя, отчество и IDNP не отображаются и при сохранении остаются прежними.',
    prefilled_from: 'Заполнено из: {{source}}',
    sources: {
      Persons: 'Профиль пациента',
      CurrentUser: 'Текущий пользователь',
      Investigations: 'Исследования',
      EpidemiologyCases: 'Форма 058/у',
      SidaCases: 'Форма СПИД',
      HivAnamnesisCases: 'Карта эпидемиологического анамнеза',
      TreatmentPlans: 'Планы лечения',
      PregnancyMonitoring: 'Мониторинг беременности',
      Consultations: 'Консультации',
      SimeTb: 'SIME-TB'
    },
    header: {
      title: 'Заголовок и A. Медицинские учреждения',
      epidemiology_number: 'Эпидемиологический номер',
      epidemiology_number_hint:
        'Генерируется ИС SBTESP; заполняется после синхронизации случая 058/у.',
      anonymous_identifier: 'Анонимный идентификатор (код TESTRAP)'
    },
    institutions: {
      title: 'A. Медицинские учреждения',
      reporting_institution:
        'Медицинское учреждение, собирающее и сообщающее эпидемиологический анамнез',
      arv_institution:
        'Медицинское учреждение, где пациент состоит на учёте и получает АРВТ',
      doctor_full_name: 'Фамилия, имя врача, собравшего и сообщившего данные',
      collected_at: 'Дата сбора данных'
    },
    patient: {
      title: 'B. Данные о пациенте',
      is_anonymous: 'Пациент зарегистрирован анонимно',
      idnp: 'IDNP',
      idnp_format: 'IDNP состоит из 13 цифр и начинается с 2 или 09',
      last_name: 'Фамилия',
      first_name: 'Имя',
      birth_date: 'Дата рождения',
      gender: 'Пол',
      genders: {
        male: 'Мужской',
        female: 'Женский',
        unknown: 'Другой'
      },
      address: '9. Адрес проживания',
      country: 'Страна',
      locality: 'Район / город, населённый пункт',
      street: 'Улица',
      street_number: '№',
      apartment_number: 'Кв.',
      phone: 'Телефон',
      residence_environment: 'Место проживания',
      residence: {
        urban: 'Городское',
        rural: 'Сельское'
      }
    },
    testing: {
      title: 'C. Тестирование на ВИЧ и диагноз',
      testing_code: 'Код тестирования',
      additional_code: 'Дополнительный код',
      screening_place: 'Место скринингового тестирования',
      firstScreening: 'Первый скрининговый тест (A1)',
      secondScreening: 'Второй скрининговый тест (A2)',
      confirmation: 'Подтверждающий тест (A3)',
      test_type: 'Название теста',
      date: 'Дата',
      result: 'Результат',
      diagnosis: 'Заключительный диагноз',
      diagnosis_code: 'Код заключительного диагноза',
      diagnosis_date: 'Дата установления диагноза'
    },
    test_result: {
      positive: 'Положительный',
      negative: 'Отрицательный',
      indeterminate: 'Неопределённый'
    },
    screening_place: {
      healthCenter: 'Центр здоровья',
      hospital: 'Больница',
      consultativeDepartment: 'Консультативное отделение',
      ngo: 'НПО',
      youthFriendlyCenter: 'Центр, дружественный молодёжи',
      selfTesting: 'Самотестирование',
      penitentiary: 'Пенитенциарное учреждение',
      other: 'Другое'
    },
    transmission: {
      group_30: 'Биологическая мать получала АРВТ',
      group_31: 'Данный ребенок',
      group_32: 'Биологическая мать',
      group_34: 'Биологическая мать имела',
      group_35: 'Ребенок до постановки диагноза (если имелось)',
      title: 'D. Пути передачи',
      adult_applies:
        'На дату сбора данных пациенту 15 лет или больше: заполняются D.1 и D.3.',
      child_applies:
        'На дату сбора данных пациенту меньше 15 лет: заполняются D.2 и D.3.',
      adult_title: 'D.1 Взрослые и дети старше 15 лет',
      child_title: 'D.2 Дети младше 15 лет',
      other_title: 'D.3 Переливания, профессиональный контакт, другие риски',
      heterosexual_title: 'Гетеросексуальные контакты',
      heterosexual_required:
        'Вероятный путь (43) гетеросексуальный: вопросы 25.1–25.11 обязательны.',
      mother_heterosexual_title:
        'Гетеросексуальные контакты биологической матери',
      abroad_country: 'Страна партнёра за границей',
      first_date: 'Первая дата',
      last_date: 'Последняя дата',
      last_before_first: 'Последняя дата не может быть раньше первой',
      occupational_institution: 'Учреждение',
      occupation: 'Профессия',
      other_risks_description: 'Описание других рисков',
      q: {
        sexWithMan: 'Половой контакт с мужчиной',
        sexWithWoman: 'Половой контакт с женщиной',
        injectingDrugUse: 'Употребление инъекционных наркотиков',
        nonInjectingDrugUse: 'Употребление неинъекционных наркотиков',
        motherHivStatusId: 'ВИЧ-статус биологической матери',
        motherTestedDuringPregnancy:
          'Мать тестировалась на ВИЧ во время беременности / родов',
        motherDiagnosisDate: 'Дата подтверждения ВИЧ-диагноза матери',
        motherSimeCode: 'Номер SIME HIV матери',
        motherArvBeforePregnancy: 'Мать получала АРВ до беременности',
        motherArvDuringPregnancy: 'Мать получала АРВ во время беременности',
        motherArvAtBirth: 'Мать получала АРВ во время родов',
        breastfed: 'Ребёнок находился на грудном вскармливании',
        prophylacticArvAfterBirth:
          'Ребёнок получал профилактические АРВ после рождения',
        motherInjectingDrugUse: 'Мать употребляла инъекционные наркотики',
        motherPerinatallyInfected: 'Мать инфицирована ВИЧ перинатально',
        motherTransfusion: 'Матери переливали кровь / препараты крови',
        motherCoagulationFactors:
          'Мать получала факторы свёртывания / имеет нарушения свёртывания',
        motherTransplantOrInsemination:
          'У матери была трансплантация тканей / органов или искусственная инсеминация',
        childSexWithMan: 'Ребёнок до диагноза: половой контакт с мужчиной',
        childSexWithWoman: 'Ребёнок до диагноза: половой контакт с женщиной',
        childInjectingDrugUse: 'Ребёнок до диагноза: инъекционные наркотики',
        childNonInjectingDrugUse:
          'Ребёнок до диагноза: неинъекционные наркотики',
        transfusion: 'Переливание крови или препаратов крови',
        coagulationFactors:
          'Получатель факторов свёртывания / нарушения свёртывания',
        transplantOrInsemination:
          'Трансплантация тканей / органов или искусственная инсеминация',
        occupationalExposure: 'Медработник с профессиональным контактом',
        otherRisks: 'Другие риски',
        possibleNosocomialRoute: 'Возможный внутрибольничный путь заражения',
        cluster: 'Очаг с несколькими случаями',
        probableRouteId: 'Заключение: вероятный путь передачи'
      },
      heterosexual: {
        withHivInfectedPerson: 'С ВИЧ-инфицированным человеком',
        withInjectingDrugUser:
          'С человеком, употребляющим инъекционные наркотики',
        withBisexualMan: 'С бисексуальным мужчиной',
        withSexWorker: 'С работником секс-бизнеса или его клиентом',
        withHaemophiliac:
          'С человеком с гемофилией / нарушением свёртывания, инфицированным ВИЧ',
        withBloodRecipient: 'С реципиентом крови, инфицированным ВИЧ',
        withMultiplePartners: 'С несколькими партнёрами',
        withCasualPartners: 'Со случайными партнёрами',
        withNosocomiallyInfectedPerson:
          'С человеком, инфицированным внутрибольнично',
        withPerinatallyInfectedPerson:
          'С человеком, инфицированным перинатально',
        withPersonAbroad: 'С человеком из-за границы'
      }
    },
    family: {
      title: 'E. Данные о семье',
      woman_title: 'Для женщин',
      children_title: 'Дети пациента',
      date: 'Дата',
      child_name: 'Имя ребёнка',
      child_name_hidden: 'Скрыто (персональные данные)',
      child_birth_date: 'Дата рождения',
      child_tested: 'Тестирован на ВИЧ',
      child_result: 'Результат',
      add_child: 'Добавить ребёнка',
      q: {
        spouseInfected: 'Супруг(а) инфицирован(а) ВИЧ',
        advisedToDiscloseStatus:
          'Человеку рекомендовано сообщить партнёру о ВИЧ+ статусе',
        partnerTested: 'Половой партнёр тестирован на ВИЧ',
        gaveBirthBeforeDiagnosis: 'Рожала до подтверждения диагноза',
        currentlyPregnant: 'Беременна в настоящее время',
        pregnantAfterDiagnosis: 'Была беременна после подтверждения диагноза'
      }
    },
    clinical: {
      title: 'F. Клинические данные',
      acute_suspected: 'Подозрение на острую ВИЧ-инфекцию',
      acute_signs: 'Признаки / симптомы острого ретровирусного синдрома',
      other_evidence: 'Другие данные, указывающие на острую инфекцию',
      other_evidence_description: 'Описание других данных',
      last_negative_date: 'Дата последнего отрицательного теста на ВИЧ',
      last_negative_place: 'Место последнего отрицательного теста на ВИЧ',
      viral_load_title: 'Вирусная нагрузка (ВН)',
      cd4_title: 'Тест CD4',
      date: 'Дата',
      viral_load_first: 'Первая вирусная нагрузка',
      viral_load_latest: 'Последняя вирусная нагрузка',
      copies_per_ml: 'Копий/мл',
      undetectable: 'Неопределяемая (<40 копий/мл)',
      cd4_first: 'Первый CD4',
      cd4_latest: 'Последний CD4',
      cd4_count: 'Клеток/мкл',
      cd4_percent: '%',
      arv_treatment: 'АРВ-лечение',
      arv_start_date: 'Дата начала АРВТ',
      arv_latest_date: 'Последний приём АРВ',
      aids_stage: 'Стадия СПИД',
      aids_stage_date: 'Дата подтверждения стадии СПИД',
      aids_category: 'Клиническая категория СПИД',
      aids_cd4: 'Уровень CD4 для клинической категории',
      opportunistic_diseases: 'Оппортунистические заболевания',
      other_diseases: 'Другие заболевания (МКБ-10)',
      add_other_disease: 'Добавить другое заболевание',
      disease_date: 'Дата',
      disease_incomplete: 'Каждое заболевание выбирается из МКБ-10',
      tuberculosis: 'Туберкулёз',
      hepatitisC: 'Вирусный гепатит C',
      hepatitisB: 'Вирусный гепатит B',
      receives_treatment: 'Получает лечение',
      treatment_start_date: 'Дата начала лечения',
      first_visit: 'Дата первого визита к врачу',
      last_visit: 'Дата последнего визита к врачу',
      last_visit_before_first: 'Последний визит не может быть раньше первого'
    },
    annual_update: {
      record: 'Ежегодное обновление ECDC',
      title: 'Ежегодное обновление клинических данных (ECDC)',
      hint: 'Раздел F и поля ** вне его (3.1, 12, 13, 47.3), дополненные новыми данными системы. Проверьте значения; при сохранении они становятся данными выбранного года и новыми значениями карты (12 и 13 — и в профиле пациента).',
      year: 'Год',
      replaces_year: 'Обновление за этот год уже есть; оно будет заменено.',
      save: 'Сохранить обновление',
      success: 'Ежегодное обновление сохранено',
      history: 'История ежегодных обновлений',
      other_fields: 'Поля ** вне раздела F (3.1, 12, 13, 47.3)',
      recorded_at: 'Записано'
    },
    refresh: {
      button: 'Взять из системы',
      confirm: 'Взять данные из системы для этого раздела?',
      description:
        'Заполняются значения, которые сейчас есть в системе (например, новые результаты); введённые значения остаются там, где в системе нет данных.',
      success: 'Данные из системы получены',
      partial:
        'Часть данных из системы не удалось получить: {{sections}}. Заполните их вручную.',
      error: 'Не удалось получить данные из системы. Попробуйте ещё раз.'
    },
    prefill_warning: {
      failed_title: 'Не удалось получить данные из системы',
      failed_description:
        'Заполните карту вручную или повторите позже с помощью «Взять из системы» в каждом разделе.',
      partial_title: 'Часть данных из системы не удалось получить',
      partial_description:
        'Проверьте и заполните вручную разделы: {{sections}}. Можно повторить с помощью «Взять из системы».'
    },
    tri_state: {
      yes: 'Да',
      no: 'Нет',
      unknown: '?'
    }
  },
  epidemiology: {
    epidemiology_case: 'Эпидемиологический случай',
    epidemiology_and_sida: 'Эпидемиологические случаи и СПИД',
    add_epidemiology_case: 'Добавить эпидемиологический случай',
    no_institution_access_title: 'Ограниченный доступ к учреждению',
    no_institution_access_description:
      'У вас нет доступа к данным вашего учреждения. Вы не можете добавить эту форму. Пожалуйста, обратитесь к администратору.',
    notification: 'Уведомление',
    epidemiology_number: 'Эпидемиологический номер',
    institution_that_notified: 'Учреждение, которое уведомило',
    city: 'Район / город',
    person_who_notified: 'Имя лица, которое уведомило',
    notification_date_time: 'Дата / время уведомления',
    primary_diagnostic: 'Первичный уведомленный диагноз',
    diagnoses_title: 'Диагноз и код диагноза согласно МКБ рев. X',
    diagnostic_date_time: 'Дата / время установления диагноза',
    date_time_of_disease_onset: 'Дата / время начала болезни',
    classification_level: 'Уровень классификации случая',
    patient_information: 'Данные для идентификации пациента',
    registration_title: 'Регистрация случая в информационной системе',
    institution_that_registered: 'Учреждение, которое зарегистрировало случай',
    date_time_registration: 'Дата / время регистрации',
    person_who_registered: 'Лицо, которое зарегистрировало случай',
    updated_date: 'Дата обновления',
    final_diagnostic: 'Окончательный диагноз',
    final_diagnostic_institution:
      'Наименование учреждения, установившего окончательный диагноз',
    final_diagnostic_date: 'Дата установления',
    disease_progress: 'Форма течения болезни',
    disease_outcome: 'Исход болезни',
    disease_outcome_date: 'Дата окончания заболевания',
    death_date: 'Дата смерти',
    symptoms_title:
      'Симптомы / проявления заболевания (п. 1-9 заполняются только в неясных, тяжелых случаях и для инфекций с программой исключения)',
    patient_card_title: 'Данные для идентификации пациента',
    patient_status: {
      title: 'Статус идентификации пациента',
      identified: 'Идентифицирован',
      anonymous: 'Анонимный',
      unidentified: 'Неидентифицирован'
    },
    work_place: 'Место работы / обучения',
    work_function: 'Должность',
    last_present_date: 'Дата последнего присутствия',
    street_number: 'Дом / корпус',
    apartment_number: 'Квартира',
    patient_institution:
      'Название медицинского учреждения первичной помощи, в котором пациент состоит на учете',
    patient_institution_address:
      'Адрес медицинского учреждения, в котором состоит на учете пациент',
    general: 'Общее',
    unknown: 'Неизвестно',
    skin_and_mucous: 'Кожные и слизистые',
    neurological: 'Неврологические',
    ocular: 'Окулярные',
    respiratory: 'Респираторные',
    gastro_intestinal: 'Гастроинтестинальные',
    urinary_disorders: 'Мочевые расстройства',
    pains: 'Боли',
    other: 'Другие проявления',
    hospitalization: 'Госпитализирован',
    vaccine: 'Для инфекций, предотвращаемых вакцинацией',
    case: 'Случай изолирован или является вспышкой',
    save: 'Сохранить',
    success_create: 'Случай успешно создан',
    search_placeholder: 'Поиск по № эпидемиологическому, дате и т. д.',
    status: {
      draft: 'Черновик',
      new: 'Новый',
      synchronised: 'Синхронизирован'
    },
    sbtesp_code: 'Код SBTESP',
    synchronised_at: 'Дата подтверждения',
    created_at: 'Дата добавления в систему',
    new_cases: 'В систему добавлены {{count}} новых случаев',
    new_case: 'В систему добавлен новый случай',
    case_description:
      'Новый пациент с ID {{simeCode}} был найден в населённом пункте {{location}}, пол {{gender}} ({{age}} лет).',
    symptoms: {
      general: {
        dontKnow: 'Неизвестно',
        doesntKnow: 'Неизвестно',
        yes: 'Да',
        no: 'Нет',
        unknown: 'Неизвестно',
        yesAccordingToSchedule: 'Да, согласно схеме',
        yesWithViolations: 'Да, с нарушением схемы/неполностью',
        fever: 'Лихорадка',
        frisoane: 'Озноб',
        pronouncedWeakness: 'Выраженная слабость',
        seriousCondition: 'Тяжёлое состояние',
        coma: 'Кома',
        persistentCrying: 'Постоянный плач'
      },
      appearanceDate: 'Дата появления',
      skinAndMucous: {
        rashes: 'Кожные высыпания',
        maculoPapular: 'Макуло-папулёзные',
        microPapular: 'Микро-папулёзные',
        vesicles: 'Везикулы',
        hemoragic: 'Геморрагические',
        petehii: 'Петехии',
        eritem: 'Эритема',
        pustule: 'Пустулы',
        carbuncul: 'Карбункул',
        sancru: 'Шанкр',
        icter: 'Желтуха',
        injuries: 'Повреждения',
        animalBite: 'Укус животного',
        arthropodBite: 'Укус членистоногого'
      },
      neurological: {
        consciousnessDisorders: 'Нарушения сознания',
        meningealSigns: 'Менингеальные признаки',
        convulsionsInvoluntaryMovements: 'Судороги / непроизвольные движения',
        hydrophobia: 'Гидрофобия',
        palsiesParalysis: 'Парезы / параличи',
        acute: 'Острые',
        flaccid: 'Вялые',
        spastic: 'Спастические',
        limbParalysis: 'Паралич конечностей',
        facialParalysis: 'Лицевой паралич',
        trunkParalysis: 'Паралич туловища',
        symmetric: 'Симметричные',
        asymmetric: 'Асимметричные',
        muscleContractures: 'Мышечные контрактуры',
        trism: 'Тризм',
        neckRigidity: 'Ригидность затылочных мышц',
        trunkMuscles: 'Мышцы туловища',
        limbMuscles: 'Мышцы конечностей'
      },
      ocular: {
        conjunctivitis: 'Конъюнктивит',
        photophobia: 'Светобоязнь',
        diplopia: 'Диплопия',
        conjunctivalCongestion: 'Конъюнктивальная гиперемия'
      },
      respiratory: {
        rhinitis: 'Ринит',
        nasalHemorrhage: 'Носовое кровотечение',
        pharyngitisLaryngitis: 'Фарингит / ларингит',
        aerophobia: 'Аэрофобия',
        cough: 'Кашель',
        oneToTwoWeeks: '1-2 недели',
        moreThanTwoWeeks: 'Более 2 недель',
        paroxysmal: 'Приступообразный',
        mucopurulent: 'Слизисто-гнойный',
        bloodySputum: 'Мокрота с кровью',
        tonsillitis: 'Тонзиллит',
        membranous: 'Плёнчатый',
        cataral: 'Катаральный',
        purulent: 'Гнойный',
        necrotic: 'Некротический'
      },
      gastroIntestinal: {
        lossOfAppetite: 'Потеря аппетита',
        nausea: 'Тошнота',
        swallowingDifficulties: 'Затруднения при глотании',
        bloodInStool: 'Кровь в стуле',
        acolicStool: 'Ахоличный стул',
        tenesmus: 'Тенезмы',
        vomiting: 'Рвота',
        diarrhea: 'Диарея',
        dehydration: 'Обезвоживание'
      },
      urinaryDisorders: {
        oliguriaAnuria: 'Олигурия / анурия',
        hyperchromicUrine: 'Гиперхромная моча',
        hematuria: 'Гематурия',
        cloudyUrine: 'Мутная моча',
        frequentMicturition: 'Частое мочеиспускание'
      },
      pains: {
        headache: 'Головная боль',
        jointPain: 'Боли в суставах',
        musclePain: 'Мышечные боли',
        abdominalPain: 'Боли в животе',
        rightHypochondriumPain: 'Правое подреберье',
        epigastricPain: 'Эпигастрий'
      },
      other: {
        lymphNodeSwelling: 'Увеличение лимфатических узлов',
        occipitalLymphNodes: 'Затылочные лимфоузлы',
        submandibularLymphNodes: 'Подчелюстные лимфоузлы',
        axillaryLymphNodes: 'Подмышечные лимфоузлы',
        salivaryGlandSwelling: 'Увеличение слюнных желёз',
        otherSymptom: 'Другие'
      },
      hospitalization: {
        title: 'Название учреждения',
        hospitalizationDate: 'Дата госпитализации'
      },
      vaccine: {
        patientVaccinated: 'Был ли пациент вакцинирован?',
        numberOfDoses: 'Количество доз',
        lastDoseDate: 'Дата последней дозы'
      },
      caseType: {
        singleCase: 'Изолированный случай',
        outbreakCase: 'Случай вспышки'
      }
    },
    per_day: 'раз в день',
    severity: 'степень',
    access_requests:
      'У вас {{count}} новых запросов на доступ к личным данным от эпидемиолога',
    access_request:
      'У вас новый запрос на доступ к личным данным от эпидемиолога',
    access_request_description:
      'Запрос на доступ к личным данным для пациента {{lastName}} {{firstName}} с кодом sime {{simeCode}}',
    success_accept_request: 'Запрос успешно принят',
    success_refuse_request: 'Запрос успешно отклонён',
    refuse_reason: 'Причина отклонения',
    access_requests_title: 'Запросы на доступ к личным данным',
    confirm_access_request: 'Подтвердить доступ к личным данным пациента?',
    refuse_access_request: 'Отказать в доступе к личным данным пациента?',
    residential_address: 'Официальный адрес проживания',
    address: 'Фактический адрес проживания',
    institution_classification:
      'Классификация учреждения согласно предоставляемым услугам',
    residence_environment: 'Среда проживания'
  },
  transfer: {
    title: 'Перевод пациента',
    from_institution: 'Из медицинского учреждения',
    to_institution: 'В медицинское учреждение',
    start_date_from: 'Начало от',
    start_date_to: 'Начало с',
    end_date_from: 'Завершение от',
    end_date_to: 'Завершение работы с',
    start_date_asc: 'Инкрементная дата начала',
    start_date_desc: 'Дата начала по убыванию',
    end_date_asc: 'Дата окончания по возрастанию',
    end_date_desc: 'Конечная дата по убыванию',
    start_date: 'Начальная дата',
    end_date: 'Конечная дата',
    transfer: 'Transfer',
    new: 'New',
    pending: 'Pending',
    rejected: 'Отклонено',
    accepted: 'Принято',
    transferred: 'Передано',
    search_placeholder: 'Поиск по IDNP, SIM-коду, имени, фамилии и т.д.',
    created_at_asc: 'Дата создания (A - Z)',
    created_at_desc: 'Дата создания (Z - A)',
    sime_code_asc: 'SIM-код (A - Z)',
    sime_code_desc: 'SIM-код (Z - A)',
    tarv_code_asc: 'Код TARV (A - Z)',
    tarv_code_desc: 'TARV-код (Z - A)',
    gender_asc: 'Ген (A - Z)',
    gender_desc: 'Gen (Z - A)',
    reject: 'Отклонить',
    reject_transfer: 'Отказаться от передачи',
    approve_transfer: 'Одобрить передачу',
    take_data_from_mconnnect: 'Получить данные через MConnect',
    search_in_mconnect: 'Поиск в Mconnect',
    transfer_approved: 'Перенос одобрен',
    verified_data_mconnect: 'Данные, проверенные через MConnect',
    get_data_from_mconnect: 'Получить данные из MConnect',
    transfer_type: 'Тип перевода',
    permanent: 'Постоянный',
    temporary: 'Временный'
  },
  funding_source: {
    delete: 'Удалить источник финансирования?',
    create: 'Создать источник финансирования',
    create_success: 'Источник финансирования создан с успехом'
  },
  active_substances: {
    prefix: 'Префикс',
    create_substance: 'Добавить активное вещество',
    create_substance_success: 'Активное вещество было успешно добавлено',
    delete_substance_title: 'Вы удаляете активное вещество?'
  },
  consultation_form: {
    primary_title: 'Форма для первичного осмотра взрослого и подростка',
    secondary_title: 'Форма для повторного осмотра взрослого и подростка',
    covered_diseases: 'Перенесённые заболевания и болезни',
    surgeries_in_anamnesis: 'Хирургические вмешательства в анамнезе',
    its_in_anamnesis: 'ИППП в анамнезе',
    syphilis: 'Сифилис',
    no_specification: 'Не указано',
    vaccines: 'Вакцинации',
    national_calendar: 'Национальный календарь прививок',
    vaccines_other: 'другие вакцины, указать',
    type: {
      primary: 'Первичная',
      secondary: 'Вторичная'
    },
    allergies: {
      allergies: 'Аллергии',
      medicines: 'Медикаментозные аллергии',
      food: 'Пищевая аллергия',
      other: 'Другие аллергены',
      medicine_allergies: 'лекарственные, указать',
      food_allergies: 'пищевые, указать',
      other_allergies: 'другие аллергены, указать'
    },
    body_constitution_changes: {
      title: 'Изменения в телосложении',
      weightGain: 'увеличение веса',
      weightLoss: 'потеря в весе',
      noChanges: 'без изменений'
    },
    current_medication: 'Текущие медикаменты',
    to_specify: 'указать',
    family_medical_anamnesis: {
      title: 'Семейный медицинский анамнез',
      diabetesMellitus: 'сахарный диабет',
      skinLesions: 'кожные поражения',
      hypertension: 'гипертония',
      malignantFormations: 'злокачественные образования и т.д.'
    },
    tb_patients_contacts:
      'Контакты с пациентами с ТБ (пациента или его членов семьи)',
    substance_consumption: {
      title: 'Употребление веществ:',
      drugs: 'Наркотики (в прошлом и в настоящем)',
      smoking: 'Курение',
      alcohol: 'Алкоголь'
    },
    reproductive_and_sexual_health: {
      title: 'Репродуктивное и сексуальное здоровье',
      yes: 'Да',
      no: 'Нет',
      contraception: 'Контрацепция'
    },
    pregnancy: {
      title: 'Беременность',
      previous_pregnancy: 'Предыдущая беременность',
      current_pregnancy: 'Текущая беременность',
      previous: 'Предыдущие, указать количество и результат',
      current: 'Текущая, указать срок',
      planned: 'Запланированные'
    },
    social_anamnesis: {
      title: 'Социальный анамнез',
      studies: {
        title: 'Образование',
        highEducation: 'Высшее',
        primaryEducation: 'Начальное',
        mediumEducation: 'Среднее',
        noEducation: 'Без образования'
      },
      employment_and_occupation: 'Трудовая деятельность и профессия'
    },
    anamnesis_section: 'АНАМНЕЗ',
    physical_examination_section: 'ФИЗИЧЕСКИЙ ОСМОТР',
    accusations: 'Обвинения',
    general_state: {
      title: 'Общее состояние',
      satisfactory: 'Удовлетворительное',
      mediumGravity: 'Средней тяжести',
      grave: 'Тяжелое',
      extremelyGrave: 'Крайне тяжелое'
    },
    conscience: {
      title: 'Сознание',
      clear: 'Ясное',
      confused: 'Запутанное',
      coma: 'Кома',
      delirium: 'Делирий'
    },
    position: {
      title: 'Положение',
      active: 'Активное',
      passive: 'Пассивное',
      forced: 'Принудительное'
    },
    constitutional_type: {
      title: 'Конституциональный тип',
      astenic: 'Астенический',
      normostenic: 'Нормостенический',
      hyperstenic: 'Гиперстенический'
    },
    vital_physiological_indices: 'Жизненно важные физиологические индексы',
    pulse: 'Пульс',
    temperature: 'Температура',
    hypertension: 'Артериальное давление',
    breathing_frequency: 'Частота дыхания',
    peripheral_lymph_nodes: {
      title: 'Периферические лимфатические узлы',

      enlarged: 'Увеличены, указать группу',
      notEnlarged: 'Не увеличены',
      details: {
        enlarged: 'Увеличены',
        notEnlarged: 'Не увеличены'
      }
    },
    cutaneous_teguments: {
      title: 'Кожные покровы',
      activeSignsOfShingles: 'Активные признаки опоясывающего лишая',
      vascularStars: 'Сосудистые звездочки',
      placesToInjectDrugs: 'Места для инъекций наркотиков',
      postSignsOfShingles: 'Пост признаки опоясывающего лишая',
      seborrheicDermatitis: 'Себорейный дерматит',
      otherModifications: 'Другие изменения, уточнить'
    },
    oropharynx: {
      title: 'Орофаринкс',
      noModification: 'Без изменений',
      villousLeukoplakiaOfTheOralCavity: 'Волосистая лейкоплакия полости рта',
      modification: 'С изменениями, уточнить',
      candidalStomatitis: 'Кандидозный стоматит',
      primarySyphilis: 'Первичный сифилис'
    },
    chest_and_lungs: {
      title: 'Грудная клетка и легкие',
      chest_form: 'Форма грудной клетки',
      symmetric: 'Симметричная',
      asymmetric: 'Асимметричная',
      auscultatory: 'Аускультативно',
      rales: 'Хрипы',
      vesicular_sounds: 'Везикулярные звуки',
      wet: 'Влажные',
      dry: 'Сухие',
      mixed: 'Смешанные',
      diminishing: 'Ослабленные',
      normal: 'Обычные',
      attenuated: 'Ослабленные'
    },
    cardiac_exam: {
      title: 'Кардиологический осмотр',
      auscultatory_cardiac_exam: 'Аускультативно',
      noModifications: 'Без изменений',
      heartMurmurs: 'Шумы сердца',
      arrhythmia: 'Аритмия, уточнить',
      otherModifications: 'Другие изменения'
    },
    abdominal_gastrointestinal_assessment: {
      title: 'Осмотр живота и желудочно-кишечной системы',
      liver: 'Печень',
      isPalpable: 'Прощупывается',
      isNotPalpable: 'Не прощупывается',
      isPainful: 'Болезненная',
      isNotPainful: 'Не болезненная',
      consistency: 'Консистенция',
      soft: 'Мягкая',
      elastic: 'Эластичная',
      hard: 'Твердая',
      spleen: 'Селезенка',
      intestinalMotility: 'Перистальтика кишечника',
      present: 'Присутствует перистальтика',
      absent: 'Отсутствует перистальтика',
      abdominalSensitivity: 'Чувствительность живота при пальпации',
      isSensitive: 'Чувствительный',
      isInsensitive: 'Не чувствительный',
      hasMuscleRigidity: 'Ригидность брюшных мышц',
      digestiveSigns: 'Пищеварительные симптомы',
      hasNausea: 'Тошнота',
      hasVomiting: 'Рвота',
      hasDysphagia: 'Дисфагия'
    },
    genital: {
      title: 'Осмотр половых и анальных органов',
      hasHerpesSimplex: 'Герпес простой',
      hasPrimarySyphilis: 'Первичный сифилис',
      hasCondylomas: 'Остроконечные кондиломы',
      hasOtherPathologies: 'Другие патологии, уточнить'
    },
    neuorological: {
      title: 'Неврологическое состояние',
      meningeal_signs: 'Менингеальные знаки',
      isPositive: 'Положительные, уточнить',
      isNegative: 'Отрицательные'
    },
    visual_functions: {
      title: 'Зрительные функции'
    },
    isAffected: 'Затронуты, уточнить',
    affected: 'Сохранены',
    isNotAffected: 'Сохранены',
    auditive_functions: {
      title: 'Слуховые функции'
    },
    urinary: {
      title: 'Мочевыделительная система',
      urination: 'Мочеиспускание',
      isFree: 'Свободное',
      isPainful: 'Болезненное',
      isDifficult: 'С трудностями',
      isNotPainful: 'Не болезненное',
      tapping_symptom: 'Симптом Дулнева',
      isPositiveBilateral: 'Положительный с двух сторон',
      isNegativeBilateral: 'Отрицательный с двух сторон',
      isPositiveUnilateral: 'Положительный с одной стороны, уточнить',
      positiveUnilateral: 'Положительный с одной стороны',
      defecation: 'Особенности дефекации',
      hasConstipation: 'Запор',
      hasNoPeculiarities: 'Без особенностей',
      hasDiarrhea: 'Понос',
      fecal: 'Характер кала',
      isSemiLiquid: 'Полужидкий',
      isLiquid: 'Жидкий',
      isFormed: 'Оформленный',
      isNormal: 'Обычный',
      hasBloodStreaks: 'Со следами крови',
      hasMucus: 'С слизью',
      hasPus: 'С гноем'
    }
  },
  cron: {
    select_schedule: 'Выберите программу',
    schedule: 'Расписание',
    every_text: 'каждый',
    empty_months: 'каждый месяц',
    empty_month_days: 'каждый день месяца',
    empty_month_days_short: 'день месяца',
    empty_week_days: 'каждый день недели',
    empty_week_days_short: 'день недели',
    empty_hours: 'каждый час',
    empty_minutes: 'каждую минуту',
    empty_minutes_for_hour_period: 'каждую',
    year_option: 'год',
    month_option: 'месяц',
    week_option: 'неделя',
    day_option: 'день',
    hour_option: 'час',
    minute_option: 'минута',
    reboot_option: 'перезагрузка',
    prefix_period: 'Каждый',
    prefix_months: 'в',
    prefix_month_days: 'в',
    prefix_week_days: 'в',
    prefix_week_days_for_month_and_year_period: 'и',
    prefix_hours: 'в',
    prefix_minutes: ':',
    prefix_minutes_for_hour_period: 'в',
    suffix_minutes_for_hour_period: 'минут(ы)',
    error_invalid_cron: 'Неверное выражение cron',
    clear_button_text: 'Очистить',
    start_data_administration: 'Дата начала администрирования',
    end_data_administration: 'Дата окончания администрирования'
  },
  equipments: {
    search_placeholder: 'Поиск оборудования',
    add_new_equipment: 'Добавить новое оборудование',
    code: 'Уникальный код',
    add_new_device: 'Добавить новое устройство',
    device_search_placeholder: 'Поиск устройства',
    inspection_period: 'Период осмотра',
    add_device: 'Добавить устройство',
    edit_device: 'Редактировать устройство',
    create_success_device: 'Устройство успешно создано',
    edit_success_device: 'Устройство успешно изменено',
    delete_device: 'Удалить устройство?',
    delete_success_device: 'Устройство успешно удалено',
    last_inspection_date: 'Дата последней проверки',
    device_type: 'Тип устройства',
    create_success_equipment: 'Оборудование успешно создано',
    edit_success_equipment: 'Оборудование успешно отредактировано',
    add_equipment: 'Добавить оборудование',
    edit_equipment: 'Редактировать оборудование',
    delete_success_equipment: 'Оборудование успешно удалено',
    delete_equipment: 'Удалить оборудование?',
    equipment: 'Оборудование',
    technical_inspections: 'Технические осмотры',
    add_inspection: 'Добавить технический осмотр',
    examination_date: 'Дата осмотра',
    success_create_inspection: 'Осмотр был успешно добавлен'
  },
  laboratory_classifiers: {
    value_options: 'Значения / Опции',
    delete_option: 'Удалить эту опцию?',
    add_option: 'Добавить опцию',
    edit_option: 'Редактировать опцию',
    delete_success_option: 'Опция была успешно удалена',
    create_success_option: 'Опция была успешно создана',
    edit_success_option: 'Опция была успешно изменена',
    reference_intervals: 'Референсные интервалы',
    min_value: 'Минимальное значение',
    max_value: 'Максимальное значение',
    min_value_error: 'Минимальное значение не может быть больше максимального',
    min_max_value_error: 'Укажите хотя бы одно из значений',
    test_types: 'Типы тестов',
    result_type: 'Тип результата',
    unit_measure: 'Единица измерения',
    result_options: 'Варианты результата',
    value_option_result: 'Значение / Вариант результата',
    reference_interval_result: 'Референсный интервал',
    add_test_type: 'Добавить тип теста',
    is_tb: 'Тип исследования ТБ',
    is_rapid_test:
      'Экспресс-тест для скрининга (доступен в заявке на скрининг)',
    edit_test_type: 'Редактировать тип теста',
    delete_success_test_type: 'Тип теста успешно удален',
    create_success_test_type: 'Тип теста успешно создан',
    edit_success_test_type: 'Тип теста успешно изменен',
    delete_test_type: 'Удалить этот тип теста?',
    investigation_type: 'Тип исследования',
    add_investigation_type: 'Добавить тип исследования',
    edit_investigation_type: 'Редактировать тип исследования',
    delete_success_investigation_type: 'Тип исследования успешно удалён',
    create_success_investigation_type: 'Тип исследования успешно создан',
    edit_success_investigation_type: 'Тип исследования успешно изменён',
    delete_investigation_type: 'Удалить этот тип исследования?',
    investigation_title: 'Название исследования',
    investigation_short_title: 'Краткое название исследования',
    investigation_category: 'Категория исследования',
    investigation_infection: 'Инфекция',
    work_method: 'Метод работы',
    work_method_domain: 'Область метода работы',
    specimen_storage: 'Условия хранения образцов',
    medical_speciality: 'Медицинская специальность',
    select_institution_categories: 'Выберите категории текущего учреждения',
    select_other_institution_categories:
      'Выберите категории из другого учреждения',
    select_institution: 'Выберите учреждение',
    select_category_error: 'Выберите хотя бы одну категорию',
    type: {
      all: 'Все',
      laboratory: 'Лаборатория',
      screening: 'Скрининг',
      suportScreening: 'Поддержка скрининга',
      internalLaboratory: 'Внутренняя лаборатория'
    },
    person: {
      all: 'Все',
      anonymous: 'Анонимные',
      identified: 'Идентифицированные'
    },
    allowed_modules: 'Допустимые модули',
    allowed_persons: 'Допустимые типы лиц',
    select_laboratory_institution: 'Выберите лабораторию',
    selected_institution: 'Выбранное учреждение',
    no_investigations_for_current_institution:
      'Для текущего учреждения не настроены исследования. Выберите другое учреждение, где будет проведён тест.',
    value_option_type: 'Семантический тип результата',
    value_option_type_options: {
      positive: 'Положительный',
      negative: 'Отрицательный',
      others: 'Другие'
    },
    test_type_category: 'Категория теста',
    category: 'Категория',
    test_type_category_options: {
      a1: 'A1',
      a2: 'A2',
      a3: 'A3',
      other: 'Другое'
    }
  },
  specimens: {
    add_investigation: 'Добавить образец',
    code: 'Код',
    prefix: 'Префикс',
    type: 'Тип',
    category: 'Категория',
    created_by: 'Создан',
    created_at: 'Создан',
    harvested_by: 'Собран',
    harvested_at: 'Собран',
    received_by: 'Получен',
    received_at: 'Получен',
    person: 'Человек',
    specimen_type: 'Тип образца',
    investigation_added: 'Исследование было успешно добавлено',
    investigations_added: 'Исследования были успешно добавлены',
    investigation_add_failed: 'Не удалось добавить «{{type}}»: {{error}}',
    investigation_test_type: 'Тип исследования',
    investigation_tests: 'Исследования',
    result_value: 'Значение результата',
    result_option: 'Вариант результата',
    test_type: 'Тип теста'
  },
  localities: {
    raion: 'Район',
    city: 'Город',
    municipalSector: 'Сектор муниципия',
    municipality: 'Муниципий',
    localityWithinTheCityOrMunicipality: 'Населённый пункт в составе города',
    villageOrCommune: 'Село/Коммуна',
    localityWithinTheVillageOrCommune: 'Населённый пункт в составе села'
  },
  medical_assistance: {
    primaryMedicalCare: 'Первичная медицинская помощь',
    hospitalMedicalCare: 'Стационарная медицинская помощь',
    emergencyMedicalCare: 'Неотложная медицинская помощь',
    consultativeMedicalCare: 'Консультативная медицинская помощь',
    laboratory: 'Лаборатория',
    others: 'Другое',
    penitentiary: 'Тюрьма'
  },
  risk_groups: {
    add_new_group: 'Добавить новую группу риска',
    edit_title: 'Редактировать группу риска',
    add_title: 'Добавить группу риска',
    parent_category: 'Родительская категория',
    for_kids: 'Группа риска для детей',
    success_edit: 'Группа риска была успешно изменена',
    success_create: 'Группа риска была успешно создана',
    success_delete: 'Группа риска была успешно удалена',
    delete_title: 'Удалить эту группу риска?',
    start_date: 'Дата добавления',
    end_date: 'Дата завершения',
    risk_group: 'Группа риска',
    finalize: 'Удалить из группы риска',
    success_finalize: 'Человек был удалён из группы риска',
    add_to_group: 'Добавить в группу риска',
    success_add: 'Человек был успешно добавлен в группу риска',
    preventive_treatment_recommended: 'Рекомендуется профилактическое лечение',
    success_remove: 'Группа риска была успешно удалена',
    exclusion_reason: 'Причина исключения',
    removed_at: 'Дата исключения',
    removed_by: 'Исключён'
  },
  screening: {
    screening_number: '№ скрининга',
    search_placeholder: 'Поиск по № скрининга',
    created_by: 'Создан',
    add_screening: 'Добавить скрининг',
    exam_date: 'Дата осмотра',
    number_value: 'Числовое значение',
    isHivSeropositive: 'Это HIV-позитивный',
    result: 'Результат',
    preventive_treatment: 'Рекомендуется профилактическое лечение',
    accept_treatment:
      'Для снижения риска инфекции, врач рекомендует начать профилактическое лечение',
    date: 'Дата рекомендации',
    recommendations: 'Рекомендации',
    initiated_by: 'Создан',
    add_test: 'Добавить тест',
    remove_test: 'Удалить тест',
    test_number: 'Тест {{number}}',
    tested_by: 'Врач, проводивший первичное тестирование',
    duplicate_test: 'Этот тип теста уже добавлен для этого исследования'
  },
  treatment_types_classifier: {
    search_placeholder: 'Поиск по типу лечения',
    treatment_type: 'Тип лечения',
    create_treatment_type: 'Добавить тип лечения',
    delete_treatment_type_title: 'Удалить этот тип лечения?',
    create_success_treatment_type: 'Тип лечения успешно создан',
    edit_success_treatment_type: 'Тип лечения успешно изменен',
    delete_success_treatment_type: 'Тип лечения успешно удален',
    delete_treatment_type: 'Удалить этот тип лечения?'
  },
  templates: {
    create_treatment_template: 'Создать шаблон лечения',
    treatment_templates: 'Шаблоны лечения'
  },
  cuatm: {
    add_cuatm: 'Добавить элемент CUATM',
    delete_success: 'Элемент CUATM успешно удален',
    delete_title: 'Удалить этот элемент CUATM ?',
    edit_title: 'Редактировать элемент CUATM',
    parent: 'Элемент родитель',
    statistic_code: 'Статистический код',
    abbreviation: 'Аббревиатура',
    create_success: 'Элемент CUATM успешно создан',
    edit_success: 'Элемент CUATM успешно изменен'
  },
  charts: {
    months: 'Месяцы',
    cd4_cells_per_micro_liter: 'CD4 клетки/мкл'
  },
  screening_tb: {
    title: 'Скрининг ТБ',
    sime_code: 'Код SIME',
    status: 'Статус',
    transmitted: 'Передан в ТБ',
    not_transmitted: 'Не передан',
    tab_all: 'Все',
    tab_transmitted: 'Переданные',
    tab_not_transmitted: 'Не переданные',
    tb_institution: 'Учреждение ТБ',
    tb_doctor: 'Врач ТБ',
    not_assigned: 'Не назначен'
  }
}

export default ru
